/*
  CRO2610: behaviour for the CRO2610 sections.
  Loaded (deferred) by snippets/cro2610-assets.liquid. Several sections may include it, so it only starts once.
*/
(function () {
  if (window.__cro2610) return;
  window.__cro2610 = true;

  var doc = document;
  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn);
  }
  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }

  // Previewing an alternate template with ?view=cro2610: keep that view on links inside the store,
  // so the preview does not drop back to the current design after one tap.
  var VIEW = (function () {
    try { return new URL(window.location.href).searchParams.get('view') || ''; } catch (e) { return ''; }
  })();
  function withView(href) {
    if (!VIEW) return href;
    try {
      var u = new URL(href, window.location.href);
      if (u.origin !== window.location.origin) return href;
      if (!/^\/($|collections\/|products\/)/.test(u.pathname) && !/\/products\//.test(u.pathname)) return href;
      if (!u.searchParams.has('view')) u.searchParams.set('view', VIEW);
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }
  if (VIEW) {
    doc.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var raw = a.getAttribute('href');
      if (!raw || raw.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(raw)) return;
      var next = withView(raw);
      if (next !== raw) a.setAttribute('href', next);
    }, true);
  }

  // ---------------------------------------------------------------- reveal on scroll
  // Only things that start below the screen are hidden, and only once this script is running,
  // so nothing a shopper should see first ever waits for JavaScript.
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      each(entries, function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('tw-wait');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    each(doc.querySelectorAll('.tw-reveal'), function (el) {
      if (el.getBoundingClientRect().top > vh * 0.95) { el.classList.add('tw-wait'); io.observe(el); }
    });
  }

  // ---------------------------------------------------------------- hero video
  // sections/cro2610-hero.liquid prints an empty <video> over the hero picture. The file is asked for only after
  // that picture is on screen (it is the page's main image and must not wait behind a video), and never for
  // visitors who prefer reduced motion or save data. Phones get the lighter file. The video fades in once it is
  // really playing and stops while the hero is off screen or the tab is hidden. The pause button is optional
  // (section setting, off by default).
  function heroVideo() {
    each(doc.querySelectorAll('[data-tw-hero-video]'), function (video) {
      var hero = video.closest('.tw-hero'), ctl = hero && hero.querySelector('[data-tw-hero-ctl]');
      var conn = navigator.connection || {};
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
      var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var src = (phone ? video.getAttribute('data-phone') : video.getAttribute('data-wide')) || video.getAttribute('data-wide');
      // iPhones play Shopify's adaptive stream by themselves: it starts with a light picture and sharpens as it goes
      var stream = phone ? video.getAttribute('data-phone-stream') : '';
      if (stream && video.canPlayType && video.canPlayType('application/vnd.apple.mpegurl')) {
        var file = src;
        video.addEventListener('error', function () { if (video.getAttribute('src') !== file) { video.src = file; video.play().catch(function () {}); } });
        src = stream;
      }
      if (!src) return;
      var stopped = false, started = false, seen = true;
      function paint() { if (ctl) { ctl.setAttribute('aria-pressed', stopped ? 'true' : 'false'); ctl.setAttribute('aria-label', stopped ? 'Play the video' : 'Pause the video'); } }
      function play() {
        if (stopped || !seen || doc.hidden) return;
        var p = video.play();
        // a phone in low power mode refuses to start a video by itself: the picture stays and the button offers it
        if (p && p.catch) p.catch(function () { stopped = true; if (ctl) ctl.hidden = false; paint(); });
      }
      function start() {
        if (started) return;
        started = true;
        video.muted = true;
        video.addEventListener('playing', function () { video.classList.add('is-on'); if (ctl) ctl.hidden = false; paint(); });
        video.src = src;
        play();
      }
      var img = hero && hero.querySelector('.tw-hero__img');
      if (!img || (img.complete && img.naturalWidth)) start();
      else { img.addEventListener('load', start); img.addEventListener('error', start); setTimeout(start, 4000); }
      if (ctl) ctl.addEventListener('click', function () {
        stopped = !stopped;
        if (stopped) video.pause(); else play();
        paint();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          seen = entries[0].isIntersecting;
          if (!started) return;
          if (seen) play(); else video.pause();
        }, { threshold: 0.15 }).observe(hero || video);
      }
      doc.addEventListener('visibilitychange', function () { if (!started) return; if (doc.hidden) video.pause(); else play(); });
    });
  }

  // ---------------------------------------------------------------- pot preview
  doc.addEventListener('click', function (e) {
    var pick = e.target && e.target.closest ? e.target.closest('.tw-pot__pick') : null;
    if (!pick) return;
    var box = pick.closest('.tw-pot');
    if (!box) return;
    var i = pick.getAttribute('data-i');
    each(box.querySelectorAll('.tw-pot__pick'), function (b) {
      var on = b === pick;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    each(box.querySelectorAll('.tw-pot__pot'), function (img) { img.hidden = img.getAttribute('data-i') !== i; });
    var label = box.querySelector('.tw-pot__label');
    if (label) label.textContent = pick.getAttribute('data-label') || '';
  });

  // ---------------------------------------------------------------- plant finder
  // Four questions that lead to plants. Before each question it asks the store how many in-stock plants
  // each answer would leave (sections/cro2610-facets.liquid) and hides the answers that would leave none,
  // so the shopper can never end on an empty result. The last step shows the first three matches.
  function finder(el) {
    var steps = el.querySelectorAll('.tw-finder__step');
    var bar = el.querySelector('.tw-finder__bar i');
    var back = el.querySelector('.tw-finder__back:not([data-tw-finder-skip]):not([data-tw-finder-restart])');
    var skip = el.querySelector('[data-tw-finder-skip]');
    var restart = el.querySelector('[data-tw-finder-restart]');
    var count = el.querySelector('[data-tw-finder-count]');
    var go = el.querySelector('[data-tw-finder-go]');
    var tags = el.querySelector('.tw-finder__tags');
    var none = el.querySelector('[data-tw-finder-none]');
    var picks = el.querySelector('[data-tw-finder-picks]');
    var base = el.getAttribute('data-collection-url') || '/collections/all';
    var extra = el.getAttribute('data-extra') || '';
    var last = steps.length - 1;
    var at = 0;
    var answers = [];
    var reqNo = 0;
    var facetCache = {};

    function decode(s) { try { return decodeURIComponent(String(s).replace(/\+/g, ' ')); } catch (e) { return s; } }
    function pairs(params) {
      if (!params) return [];
      return params.split('&').map(function (kv) { var i = kv.indexOf('='); return [decode(kv.slice(0, i)), decode(kv.slice(i + 1))]; });
    }
    function query(upTo) {
      var parts = extra ? [extra] : [];
      for (var i = 0; i < upTo; i++) if (answers[i] && answers[i].params) parts.push(answers[i].params);
      return parts.join('&');
    }
    // counts for every filter value, given the answers to the questions before step `upTo`
    function facets(upTo) {
      var q = query(upTo);
      if (!facetCache[q]) {
        facetCache[q] = fetch(base + '?' + (q ? q + '&' : '') + 'section_id=cro2610-facets', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var m = /<script[^>]*data-tw-facets[^>]*>([\s\S]*?)<\/script>/.exec(html);
            return m ? JSON.parse(m[1]) : null;
          })
          .catch(function () { return null; });
      }
      return facetCache[q];
    }
    // hide the answers of step i that would leave no plants; resolves with how many answers are left
    function prune(i) {
      var step = steps[i];
      if (!step || i >= last) return Promise.resolve(1);
      return facets(i).then(function (f) {
        var opts = step.querySelectorAll('.tw-finder__opt');
        if (!f) { each(opts, function (o) { o.hidden = false; }); return opts.length; }   // could not check: offer everything
        var open = 0;
        each(opts, function (o) {
          var ps = pairs(o.getAttribute('data-params') || '');
          var n = 0;
          if (!ps.length) n = f.count;
          else each(ps, function (kv) { n += (f.filters[kv[0]] && f.filters[kv[0]][kv[1]]) || 0; });
          o.hidden = n === 0;
          if (n > 0) open++;
          else if (o.classList.contains('is-on')) { o.classList.remove('is-on'); answers[i] = null; }
        });
        return open;
      });
    }
    function paintStep() {
      each(steps, function (s, n) { s.classList.toggle('is-on', n === at); });
      if (bar) bar.style.width = Math.round((at / last) * 100) + '%';
      if (back) back.hidden = at === 0;
      if (skip) skip.hidden = at === last;
      if (restart) restart.hidden = at !== last;
      if (at === last) result();
    }
    // move to step i; a question with one answer left (or none) is not worth asking, so it is answered
    // for the shopper and passed over in the direction of travel
    function show(i, dir) {
      i = Math.max(0, Math.min(last, i));
      if (i === last) { at = i; paintStep(); return; }
      var done = false;
      function land(open) {
        if (done) return;
        done = true;
        if (open <= 1 && !(dir < 0 && i === 0)) {
          var only = open === 1 ? steps[i].querySelector('.tw-finder__opt:not([hidden])') : null;
          answers[i] = only ? { params: only.getAttribute('data-params') || '', label: only.getAttribute('data-label') || '' } : { params: '', label: '' };
          show(i + (dir < 0 ? -1 : 1), dir);
          return;
        }
        at = i;
        paintStep();
      }
      prune(i).then(land);
      setTimeout(function () { land(9); }, 1400);   // never leave the shopper waiting on a slow answer
    }
    function result() {
      var q = query(last);
      var url = base + (q ? '?' + q : '');
      if (tags) {
        tags.textContent = '';
        each(answers, function (a) {
          if (!a || !a.params || !a.label) return;
          var t = doc.createElement('span'); t.className = 'tw-finder__tag'; t.textContent = a.label; tags.appendChild(t);
        });
      }
      if (go) { go.setAttribute('href', withView(url)); go.removeAttribute('aria-disabled'); go.style.pointerEvents = ''; go.style.opacity = ''; }
      if (count) count.textContent = '';
      if (none) none.hidden = true;
      if (picks) { picks.hidden = true; picks.textContent = ''; }
      var mine = ++reqNo;
      fetch(base + '?' + (q ? q + '&' : '') + 'section_id=cro2610-picks', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (mine !== reqNo) return;
          var m = /data-tw-count="(\d+)"/.exec(html);
          if (!m) return;
          var n = parseInt(m[1], 10);
          if (count) count.textContent = n + ' ';
          if (picks && n > 0) {
            var box = doc.createElement('div');
            box.innerHTML = html;
            var found = box.querySelectorAll('.tw-pick .tw-card');
            for (var k = 0; k < found.length && k < 3; k++) {
              each(found[k].querySelectorAll('a[href]'), function (a) { a.setAttribute('href', withView(a.getAttribute('href'))); });
              picks.appendChild(found[k]);
            }
            picks.hidden = picks.children.length === 0;
          }
          if (n === 0) {
            if (none) none.hidden = false;
            if (go) { go.setAttribute('aria-disabled', 'true'); go.style.pointerEvents = 'none'; go.style.opacity = '0.5'; }
          }
        })
        .catch(function () {});
    }

    el.addEventListener('click', function (e) {
      var opt = e.target.closest('.tw-finder__opt');
      if (opt) {
        var step = opt.closest('.tw-finder__step');
        var i = Array.prototype.indexOf.call(steps, step);
        each(step.querySelectorAll('.tw-finder__opt'), function (o) { o.classList.toggle('is-on', o === opt); });
        answers[i] = { params: opt.getAttribute('data-params') || '', label: opt.getAttribute('data-label') || '' };
        answers.length = i + 1;   // a changed answer makes the later ones stale
        setTimeout(function () { show(i + 1, 1); }, 170);
        return;
      }
      if (e.target.closest('[data-tw-finder-skip]')) { answers[at] = { params: '', label: '' }; answers.length = at + 1; show(at + 1, 1); return; }
      if (e.target.closest('[data-tw-finder-restart]')) {
        answers = [];
        each(el.querySelectorAll('.tw-finder__opt.is-on'), function (o) { o.classList.remove('is-on'); });
        show(0, 1);
        return;
      }
      if (e.target.closest('.tw-finder__back')) show(at - 1, -1);
    });

    paintStep();
    // check the first question's answers once the finder is about to be seen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (!es[es.length - 1].isIntersecting) return;
        io.disconnect();
        prune(0);
      }, { rootMargin: '600px 0px' });
      io.observe(el);
    } else {
      prune(0);
    }
  }

  // ---------------------------------------------------------------- product page: free delivery line
  function shipLine(el) {
    var threshold = parseFloat(el.getAttribute('data-threshold')) || 99;
    var msg = el.querySelector('[data-tw-ship-msg]');
    var bar = el.querySelector('.tw-ship__bar i');
    var fallback = parseFloat(el.getAttribute('data-price')) || 0;
    function read() {
      var total = doc.querySelector('[data-cv3-total-card] [data-cv3-total]');
      var n = total ? parseFloat(total.textContent.replace(/[^0-9.]/g, '')) : NaN;
      return isNaN(n) ? fallback : n;
    }
    function paint() {
      var total = read();
      if (!total) return;
      var left = Math.ceil((threshold - total) * 100) / 100;
      if (msg) msg.textContent = left <= 0 ? el.getAttribute('data-done') : el.getAttribute('data-more').replace('[amount]', '$' + (left % 1 === 0 ? left : left.toFixed(2)));
      if (bar) bar.style.width = Math.max(4, Math.min(100, Math.round((total / threshold) * 100))) + '%';
    }
    paint();
    var card = doc.querySelector('[data-cv3-total-card]');
    if (card && 'MutationObserver' in window) {
      new MutationObserver(paint).observe(card, { childList: true, subtree: true, characterData: true });
    }
  }

  // ---------------------------------------------------------------- product page: photo thumbnails
  // Where the buy-box styling is switched on this builds a small strip from the gallery's photos and
  // keeps it in step with the slides (the theme's own thumbnail row is hidden there by cro2610.css).
  function thumbs() {
    if (!doc.documentElement.classList.contains('cro2610-buybox')) return;
    var main = doc.querySelector('#slider .js-carousel-main');
    if (!main || doc.querySelector('.tw-thumbs')) return;
    var cells = main.querySelectorAll('.carousel-cell');
    if (cells.length < 2) return;
    var strip = doc.createElement('div');
    strip.className = 'tw-thumbs';
    strip.setAttribute('role', 'group');
    strip.setAttribute('aria-label', 'Product photos');
    each(cells, function (cell, i) {
      var img = cell.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('data-tw-src') || img.getAttribute('src') || '';
      if (!src || src.indexOf('data:') === 0) return;
      var small = /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=160') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'tw-thumbs__b';
      b.setAttribute('data-i', i);
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      var im = doc.createElement('img');
      im.src = small; im.alt = ''; im.loading = 'lazy'; im.width = 56; im.height = 56;
      b.appendChild(im);
      strip.appendChild(b);
    });
    if (strip.children.length < 2) return;
    main.parentNode.insertBefore(strip, main.nextSibling);
    function mark(i) {
      each(strip.children, function (b) {
        var on = +b.getAttribute('data-i') === i;
        b.classList.toggle('is-on', on);
        if (on) strip.scrollTo({ left: b.offsetLeft - strip.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' });
      });
    }
    function slider() { return window.Flickity && window.Flickity.data ? window.Flickity.data(main) : null; }
    strip.addEventListener('click', function (e) {
      var b = e.target.closest('.tw-thumbs__b');
      if (!b) return;
      var i = +b.getAttribute('data-i');
      var f = slider();
      if (f) f.select(i);
      mark(i);
    });
    var tries = 0;
    (function hook() {
      var f = slider();
      if (f) { f.on('select', function () { mark(f.selectedIndex); }); mark(f.selectedIndex || 0); }
      else if (tries++ < 60) setTimeout(hook, 250);
      else mark(0);
    })();
  }

  // ---------------------------------------------------------------- collection FAQ
  // The description's question blocks are radio inputs that only fold when the description carries its
  // own styles. Make each one an independent toggle and repair entries that lost their input or label.
  function cfaq(el) {
    var n = 0;
    each(el.querySelectorAll('.so-tab'), function (tab) {
      var content = tab.querySelector('.so-tab-content');
      if (!content) return;
      n++;
      var id = 'cro2610-faq-' + n;
      var input = tab.querySelector('input');
      var label = tab.querySelector('label');
      if (!input) { input = doc.createElement('input'); tab.insertBefore(input, tab.firstChild); }
      input.type = 'checkbox';
      input.id = id;
      input.removeAttribute('name');
      if (!label) {
        label = doc.createElement('label');
        var first = content.querySelector('h3, h4, strong, p');
        label.textContent = first ? first.textContent.replace(/\s+/g, ' ').trim().slice(0, 120) : 'More';
      }
      label.setAttribute('for', id);
      if (input.nextElementSibling !== label) tab.insertBefore(label, input.nextSibling);
    });
  }

  // ---------------------------------------------------------------- styling story on scroll
  // The stage sticks while the track scrolls past; scroll position wipes each photo in over the last
  // and swaps the words. Switched on only here, so without this script the scenes just sit in a row.
  function scrolly(el) {
    var track = el.querySelector('.tw-scrolly__track');
    var frames = el.querySelectorAll('.tw-scrolly__frame');
    var steps = el.querySelectorAll('.tw-scrolly__step');
    var dots = el.querySelectorAll('.tw-scrolly__dots i');
    var edge = el.querySelector('.tw-scrolly__edge');
    var n = frames.length;
    if (!track || n < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!(window.CSS && CSS.supports && CSS.supports('position', 'sticky') && CSS.supports('clip-path', 'inset(0 0 0 50%)'))) return;
    el.classList.add('is-live');
    var ticking = false, near = true, last = -1;
    function ease(x) { return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }
    function paint() {
      ticking = false;
      var r = track.getBoundingClientRect();
      var span = r.height - (window.innerHeight || 800);
      if (span <= 0) return;
      var p = Math.max(0, Math.min(1, -r.top / span)) * (n - 1);
      var moving = -1, amount = 0;
      each(frames, function (f, i) {
        var img = f.querySelector('.tw-scrolly__img');
        var here = Math.max(0, Math.min(1, p - (i - 1)));
        if (img) img.style.setProperty('--tw-zoom', (1.1 - 0.1 * Math.max(0, Math.min(1, p - i + 1))).toFixed(3));
        if (i === 0) return;
        var shown = ease(here);
        f.style.clipPath = 'inset(0 0 0 ' + ((1 - shown) * 100).toFixed(2) + '%)';
        if (here > 0 && here < 1) { moving = i; amount = shown; }
      });
      if (edge) {
        edge.style.opacity = moving > -1 ? '1' : '0';
        if (moving > -1) edge.style.left = ((1 - amount) * 100).toFixed(2) + '%';
      }
      var cur = Math.min(n - 1, Math.round(p));
      if (cur !== last) {
        last = cur;
        each(steps, function (s, i) { s.classList.toggle('is-on', i === cur); });
        each(dots, function (d, i) { d.classList.toggle('is-on', i === cur); });
      }
    }
    function ask() { if (near && !ticking) { ticking = true; window.requestAnimationFrame(paint); } }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { near = es[es.length - 1].isIntersecting; if (near) ask(); }, { rootMargin: '200px 0px' }).observe(el);
    }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    paint();
  }

  // ---------------------------------------------------------------- customer videos
  // Clips do not load until played. Phones: the clip that is fully on screen plays, muted.
  // Desktop: a clip plays while the pointer is over it. The round button turns that clip's sound on or off.
  function ugc(el) {
    var cards = el.querySelectorAll('.tw-ugc__card');
    if (!cards.length) return;
    var hover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    function play(card) {
      var v = card.querySelector('video');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      card.classList.add('is-playing');
    }
    function stop(card) { card.querySelector('video').pause(); card.classList.remove('is-playing'); }
    function quiet() {
      each(cards, function (c) {
        c.querySelector('video').muted = true;
        var s = c.querySelector('.tw-ugc__sound');
        if (s) { s.setAttribute('aria-pressed', 'false'); s.setAttribute('aria-label', 'Turn sound on'); }
      });
    }
    each(cards, function (card) {
      var v = card.querySelector('video');
      var s = card.querySelector('.tw-ugc__sound');
      if (hover) {
        card.addEventListener('mouseenter', function () { play(card); });
        card.addEventListener('mouseleave', function () { stop(card); });
      }
      v.addEventListener('click', function () { if (v.paused) play(card); else stop(card); });
      if (s) s.addEventListener('click', function () {
        var turnOn = v.muted;
        quiet();
        if (turnOn) { v.muted = false; s.setAttribute('aria-pressed', 'true'); s.setAttribute('aria-label', 'Turn sound off'); play(card); }
      });
    });
    if (!hover && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        each(entries, function (e) { if (e.intersectionRatio >= 0.8) play(e.target); else stop(e.target); });
      }, { threshold: [0, 0.8] });
      each(cards, function (c) { io.observe(c); });
    }
  }

  // ---------------------------------------------------------------- plant cluster (cross-sell on plant pages)
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  // Line properties that mark a plant as pot-ready: the cart drawer then shows its own "+ Add a pot" for that line.
  function potReady(x) {
    if (!x || !x.potColl) return null;
    var props = { _io_pot_collection: x.potColl };
    if (x.plantSize) props._io_plant_size = x.plantSize;
    return props;
  }
  function readPicks(root) {
    var out = [];
    each(root.querySelectorAll('.tw-pick'), function (p) {
      var card = p.querySelector('.tw-card');
      out.push({
        handle: p.getAttribute('data-handle') || '', variant: p.getAttribute('data-variant'),
        available: p.getAttribute('data-available') === 'true', stock: parseInt(p.getAttribute('data-stock'), 10) || 0,
        price: parseInt(p.getAttribute('data-price'), 10) || 0, title: p.getAttribute('data-title') || '',
        img: p.getAttribute('data-img') || '', url: p.getAttribute('data-url') || '',
        size: (p.getAttribute('data-size') || '').toUpperCase().split(/[^A-Z]+/)[0] || '',
        potColl: p.getAttribute('data-pot-coll') || '', plantSize: p.getAttribute('data-plant-size') || '',
        facts: card ? (card.getAttribute('data-facts') || '') : ''
      });
    });
    return out;
  }
  var pickCache = {};
  function fetchPicks(url) {
    if (!pickCache[url]) {
      pickCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var box = doc.createElement('div'); box.innerHTML = html; return readPicks(box); })
        .catch(function () { return []; });
    }
    return pickCache[url];
  }
  // Companions for the plant a cluster section describes, best first. `el` is the section's element
  // (on the page, or parsed from a fetched copy of the section for another product).
  // Order: chosen by hand on the product, then the product's tag group, then same light need.
  // Only plants that can be bought now; within the automatic ones, best-stocked first and a mix of sizes.
  function companions(el, max, skip) {
    var base = el.getAttribute('data-url') || '/collections/all';
    var exclude = el.getAttribute('data-exclude');
    var ownSizes = (el.getAttribute('data-own-size') || '').toUpperCase().split(/[^A-Z]+/);
    // Hand-made sets: products sharing a "plantset_…" tag (the section lists this product's set tags, three at most).
    var tags = (el.getAttribute('data-tags') || '').split(',').filter(function (t) { return t; });
    var query = el.getAttribute('data-query') || '';
    var tagged = Promise.all(tags.map(function (t) { return fetchPicks(base + '/' + encodeURIComponent(t) + '?filter.v.availability=1&section_id=cro2610-picks'); }))
      .then(function (sets) { return [].concat.apply([], sets); });
    var auto = /plant_care_light/.test(query) ? fetchPicks(base + '?' + query + '&section_id=cro2610-picks') : Promise.resolve([]);
    return Promise.all([tagged, auto]).then(function (lists) {
      var out = [], used = {}, seen = {};
      used[exclude] = true;
      each(skip || [], function (h) { used[h] = true; });
      function ok(x) { return x.available && x.variant && !used[x.handle]; }
      function add(x) { out.push(x); used[x.handle] = true; if (x.size) seen[x.size] = true; }
      function byStock(a, b) { return b.stock - a.stock; }
      each(lists[0].slice().sort(byStock), function (x) { if (out.length < max && ok(x)) add(x); });
      var rest = lists[1].slice().sort(byStock);
      // Automatic picks: first those that cost about the same as this plant or less (an add-on that costs far more
      // than the plant itself rarely gets added), then anything else so the list is never short for that reason alone.
      var own = parseFloat(el.getAttribute('data-own-price')) || 0;
      each([function (x) { return !own || x.price <= own * 1.3; }, function () { return true; }], function (fits) {
        each(rest, function (x) { if (out.length < max && ok(x) && fits(x) && x.size && !seen[x.size] && ownSizes.indexOf(x.size) === -1) add(x); });
        each(rest, function (x) { if (out.length < max && ok(x) && fits(x) && x.size && !seen[x.size]) add(x); });
        each(rest, function (x) { if (out.length < max && ok(x) && fits(x)) add(x); });
      });
      return out;
    });
  }

  function cluster(el) {
    var list = el.querySelector('[data-tw-cluster-list]');
    var sum = el.querySelector('[data-tw-cluster-sum]');
    var btn = el.querySelector('[data-tw-cluster-add]');
    if (!list || !btn) return;
    var max = parseInt(el.getAttribute('data-max'), 10) || 3;
    var pre = parseInt(el.getAttribute('data-preselect'), 10) || 0;
    var items = [];
    function paint() {
      var on = items.filter(function (x) { return x.on; });
      var total = on.reduce(function (s, x) { return s + x.price; }, 0);
      var text = on.length === 0 ? el.getAttribute('data-none') : (on.length === 1 ? el.getAttribute('data-one') : el.getAttribute('data-many'));
      btn.textContent = (text || '').replace('[count]', on.length).replace('[total]', money(total));
      btn.disabled = on.length === 0;
      if (sum) sum.textContent = '';
      each(items, function (x) { x.row.classList.toggle('is-on', x.on); x.row.setAttribute('aria-pressed', x.on ? 'true' : 'false'); });
    }
    function row(x) {
      var li = doc.createElement('li');
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'tw-cluster__item';
      if (x.img) { var im = doc.createElement('img'); im.className = 'tw-cluster__img'; im.src = x.img; im.alt = ''; im.loading = 'lazy'; im.width = 76; im.height = 95; b.appendChild(im); }
      var info = doc.createElement('span'); info.className = 'tw-cluster__info';
      var t = doc.createElement('span'); t.className = 'tw-cluster__title'; t.textContent = x.title; info.appendChild(t);
      if (x.facts) { var f = doc.createElement('span'); f.className = 'tw-cluster__facts'; f.textContent = x.facts; info.appendChild(f); }
      var pr = doc.createElement('span'); pr.className = 'tw-cluster__price'; pr.textContent = money(x.price); info.appendChild(pr);
      b.appendChild(info);
      var tick = doc.createElement('span'); tick.className = 'tw-cluster__tick';
      tick.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
      b.appendChild(tick);
      b.addEventListener('click', function () { x.on = !x.on; paint(); });
      li.appendChild(b);
      x.row = b;
      return li;
    }
    companions(el, max).then(function (found) {
      if (!found.length) return;
      items = found;
      each(items, function (x, i) { x.on = i < pre; list.appendChild(row(x)); });
      el.hidden = false;
      paint();
    });
    btn.addEventListener('click', function () {
      var on = items.filter(function (x) { return x.on; });
      if (!on.length) return;
      btn.disabled = true;
      // this add is the cluster's own: the "Added to cart" sheet is for the page's main Add to cart button
      if (window.cro2610Added && window.cro2610Added.forget) window.cro2610Added.forget();
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: on.map(function (x) { var it = { id: x.variant, quantity: 1 }, props = potReady(x); if (props) it.properties = props; return it; }) })
      })
        .then(function (r) { if (!r.ok) throw new Error('not added'); return r.json(); })
        .then(function () {
          each(items, function (x) { x.on = false; });
          paint();
          btn.textContent = el.getAttribute('data-done') || 'Added to cart';
          try { doc.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
          // the cart opens to show what went in, unless the "Added to cart" sheet is already up
          var sheetUp = window.cro2610Added && window.cro2610Added.isOpen && window.cro2610Added.isOpen();
          if (!sheetUp && window.cv3CartDrawer && typeof window.cv3CartDrawer.open === 'function') window.cv3CartDrawer.open();
          setTimeout(paint, 2600);
        })
        .catch(function () {
          btn.disabled = false;
          if (sum) sum.textContent = 'Sorry, that did not go through. Please try again.';
        });
    });
  }

  // ---------------------------------------------------------------- product page: key details card under the button
  // Free delivery is counted on the cart total after all discounts (the figure checkout uses), which only the cart
  // knows. So the line reads the cart: empty cart = the plain offer, otherwise what is still missing or "done".
  function shipState(el, cart) {
    var threshold = el ? parseFloat(el.getAttribute('data-threshold')) : 0;
    if (!threshold || !cart) return null;
    if (!cart.item_count) return { text: el.getAttribute('data-empty') || '', pct: 0, done: false, empty: true };
    var total = (cart.total_price || 0) / 100;
    var left = Math.ceil((threshold - total) * 100) / 100;
    return {
      text: left <= 0 ? (el.getAttribute('data-done') || '') : (el.getAttribute('data-more') || '').replace('[amount]', '$' + (left % 1 === 0 ? left : left.toFixed(2))),
      pct: Math.max(4, Math.min(100, Math.round((total / threshold) * 100))), done: left <= 0, empty: false
    };
  }
  function keys(el) {
    var msg = el.querySelector('[data-tw-keys-msg]'), bar = el.querySelector('[data-tw-keys-bar]');
    function paint(cart) {
      var st = shipState(el, cart);
      if (!st) return;
      if (msg && st.text) msg.textContent = st.text;
      el.classList.toggle('is-done', st.done);
      if (bar) { bar.hidden = st.empty; if (bar.firstElementChild) bar.firstElementChild.style.width = st.pct + '%'; }
    }
    var wait = 0;
    function run() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).then(paint).catch(function () {});
    }
    run();
    doc.addEventListener('cart:updated', function () { clearTimeout(wait); wait = setTimeout(run, 600); });
    // one row open at a time keeps the card short
    el.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      each(el.querySelectorAll('details[open]'), function (d) { if (d !== e.target) d.open = false; });
    }, true);
  }

  // ---------------------------------------------------------------- product page: AI studio button on the photo
  // snippets/cro2610-keys.liquid prints the button (hidden); here it moves onto the main product photo. It opens the
  // store's AI Plant Studio with this product, through the studio's own data-plant-studio-open hook.
  function studioPill() {
    // A shopper who taps "See it in your room" (or the studio card) has asked for one thing, so the studio should open
    // on its "Design your space" screen with the room-photo button, not on its first-visit welcome. The studio is its
    // own app on this address (/apps/studio) and shows the welcome until its "ps_welcomed" note is set: set it here.
    doc.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-tw-studio-pill], .tw-studio[data-plant-studio-open]') : null;
      if (!t) return;
      try { window.localStorage.setItem('ps_welcomed', '1'); } catch (err) {}
    }, true);
    var pill = doc.querySelector('[data-tw-studio-pill]');
    var main = doc.querySelector('.product__section-images .js-carousel-main');
    if (!pill || !main) return;
    // The photo slider turns every child of its element into a slide, so the button must not go in before the slider
    // is built. It goes on the slider's fixed frame once that exists; with no slider (one photo) on the photo's own box.
    var tries = 0;
    (function place() {
      var frame = main.querySelector('.flickity-viewport');
      if (frame) { frame.appendChild(pill); pill.hidden = false; return; }
      if (tries++ < 40) { setTimeout(place, 250); return; }
      var box = main.querySelector('.product-media-container');
      if (!box) return;
      if (window.getComputedStyle(box).position === 'static') box.style.position = 'relative';
      box.appendChild(pill);
      pill.hidden = false;
    })();
  }

  // ---------------------------------------------------------------- product page: after "Add to cart"
  // The theme confirms an add with a line of text under the button for three seconds ("Added to Cart, View Cart or
  // Continue Shopping"). This shows a sheet in its place: what went in (a plant with its pot and add-ons shows as one
  // set), the two ways on, and things that go with it, each added with one tap. For a plant these are the same picks
  // as the plant cluster section, whose wording it borrows; for anything else, the store's own related products.
  var sheetApi = null;               // { show, hide }, set by sheets()
  var clusterCache = {};
  function clusterFor(handle) {
    var here = doc.querySelector('[data-tw-cluster]');
    if (here && here.getAttribute('data-exclude') === handle) return Promise.resolve(here);
    if (!clusterCache[handle]) {
      clusterCache[handle] = fetch('/products/' + handle + '?section_id=cro2610-plant-cluster', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var box = doc.createElement('div'); box.innerHTML = html; return box.querySelector('[data-tw-cluster]'); })
        .catch(function () { return null; });
    }
    return clusterCache[handle];
  }
  function added() {
    var notes = doc.querySelectorAll('.js-added-msg');
    if (!notes.length || !('MutationObserver' in window)) return;
    doc.documentElement.classList.add('tw-added-on');          // cro2610.css then hides the theme's own line
    var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
    var CLOSE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    function mk(tag, cls, text) { var n = doc.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
    function getCart() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    function openCart() {
      if (sheetApi) sheetApi.hide();
      if (window.cv3CartDrawer && typeof window.cv3CartDrawer.open === 'function') { window.cv3CartDrawer.open(); return; }
      if (window.AMP_API && typeof window.AMP_API.OPEN_CART === 'function') { window.AMP_API.OPEN_CART(); return; }
      window.location.href = '/cart';
    }
    var sheet = null, parts = {};
    function build() {
      sheet = mk('div', 'tw-sheet tw-added');
      sheet.id = 'cro2610-added-sheet';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.setAttribute('aria-label', 'Added to cart');
      sheet.hidden = true;
      var shade = mk('div', 'tw-sheet__shade');
      shade.setAttribute('data-tw-sheet-close', '');
      var panel = mk('div', 'tw-sheet__panel');
      panel.tabIndex = -1;
      var x = mk('button', 'tw-sheet__close');
      x.type = 'button'; x.setAttribute('data-tw-sheet-close', ''); x.setAttribute('aria-label', 'Close'); x.innerHTML = CLOSE;
      var ok = mk('p', 'tw-added__ok');
      ok.innerHTML = '<span class="tw-added__tick">' + TICK + '</span>';
      ok.appendChild(mk('span', '', 'Added to cart'));
      parts.item = mk('div', 'tw-added__item');
      parts.extras = mk('div', 'tw-added__extras');
      parts.extras.hidden = true;
      parts.ship = mk('p', 'tw-added__ship');
      parts.ship.hidden = true;
      var btns = mk('div', 'tw-added__btns');
      parts.cart = mk('a', 'tw-added__cart', 'View cart');
      parts.cart.href = '/cart';
      parts.cart.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
      var keep = mk('button', 'tw-added__keep', 'Continue shopping');
      keep.type = 'button'; keep.setAttribute('data-tw-sheet-close', '');
      btns.appendChild(parts.cart); btns.appendChild(keep);
      parts.more = mk('div', 'tw-added__more');
      parts.more.hidden = true;
      each([x, ok, parts.item, parts.extras, parts.ship, btns, parts.more], function (n) { panel.appendChild(n); });
      sheet.appendChild(shade); sheet.appendChild(panel);
      doc.body.appendChild(sheet);
    }
    // the free delivery line uses the key details card's wording and threshold, when that card is on the page
    function paintCart(cart) {
      if (!cart) return;
      parts.cart.textContent = 'View cart' + (cart.item_count ? ' (' + cart.item_count + ')' : '');
      var st = shipState(doc.querySelector('[data-tw-keys]'), cart);
      parts.ship.hidden = !st || st.empty || !st.text;
      if (st) { parts.ship.textContent = st.text; parts.ship.classList.toggle('is-done', st.done); }
    }
    function paintItem(it, fallbackTitle, cart) {
      parts.item.textContent = '';
      if (it && it.image) { var im = doc.createElement('img'); im.alt = ''; im.width = 60; im.height = 60; im.src = String(it.image).replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'); parts.item.appendChild(im); }
      var txt = mk('span');
      txt.appendChild(mk('strong', '', it ? it.product_title : fallbackTitle));
      if (it) {
        var plain = function (v) { return v && !/^default title$/i.test(v) ? v : ''; };
        var set = [], price = it.final_line_price || it.final_price;
        var bundle = it.properties && it.properties._io_bundle_id;
        if (bundle && cart) each(cart.items, function (i) {
          if (i !== it && i.properties && i.properties._io_bundle_id === bundle) { set.push(i); price += i.final_line_price || i.final_price; }
        });
        var bits = [];
        if (plain(it.variant_title)) bits.push(it.variant_title);
        if (!set.length) bits.push(money(price));
        if (bits.length) txt.appendChild(mk('em', '', bits.join(' \u00b7 ')));
        each(set, function (i) { txt.appendChild(mk('em', 'tw-added__with', '+ ' + i.product_title + (plain(i.variant_title) ? ' \u00b7 ' + i.variant_title : ''))); });
        if (set.length) txt.appendChild(mk('em', 'tw-added__sum', money(price)));
      }
      parts.item.appendChild(txt);
    }
    // Add-ons for the chosen pot that the shopper left unticked in the pot picker (repotting, matching tray, plant
    // stand): read from the picker as it stands at the moment of the add, so only what it offered for this pot, at
    // the picker's own prices. Added the way the cart drawer adds a service to a set: same set id, its role, and
    // the plant's quantity.
    function readAddOns() {
      var out = [];
      each(doc.querySelectorAll('#pot-addon-checkboxes .addon-item'), function (card) {
        var cb = card.querySelector('input[type="checkbox"]');
        if (!cb || cb.checked || card.style.display === 'none' || !card.offsetParent) return;
        var sel = card.querySelector('select.addon-variant-select');
        var opt = sel && sel.selectedOptions ? sel.selectedOptions[0] : null;
        var id = sel ? sel.value : cb.value;
        if (!id) return;
        var type = card.getAttribute('data-addon-type') || '';
        var t = card.querySelector('.addon-title'), ic = card.querySelector('.addon-icon');
        out.push({
          id: String(id), role: type === 'repot' ? 'repot' : (type === 'saucer' ? 'tray' : 'addon'),
          service: type === 'repot' ? 'repotting' : (type === 'saucer' ? 'tray' : ''),
          price: parseInt((opt ? opt.getAttribute('data-price') : cb.getAttribute('data-price')) || '0', 10) || 0,
          title: (t ? t.textContent : '').replace(/^\s*Add\s+/i, '').replace(/\?\s*$/, '').trim(),
          option: opt && sel.options.length > 1 ? opt.textContent.trim() : '', icon: ic ? ic.getAttribute('src') : ''
        });
      });
      return out;
    }
    var missed = [];
    function paintExtras(it, cart) {
      parts.extras.textContent = '';
      parts.extras.hidden = true;
      var bid = it && it.properties ? it.properties._io_bundle_id : '';
      var roles = {}, ids = {};
      if (bid) each(cart.items, function (i) {
        var p = i.properties || {};
        if (p._io_bundle_id === bid) { roles[p._io_bundle_role] = 1; ids[String(i.variant_id)] = 1; }
      });
      if (!roles.pot) {
        // a plant that went in without a pot (and can take one): ask whether they want one. "Most customers add
        // one" is the store's own number: 49 of the 71 orders with a plant from 5 to 13 Oct 2026 had a pot or planter.
        if (!it || !it.properties || !it.properties._io_pot_collection || !it.key) return;
        parts.extras.appendChild(mk('p', 'tw-sheet__eyebrow', 'Want a pot with it?'));
        var potRow = mk('div', 'tw-added__extra');
        var potTxt = mk('span', 'tw-added__extra-t');
        potTxt.appendChild(mk('strong', '', 'Most customers add one'));
        potTxt.appendChild(mk('em', '', 'It arrives in a grow pot. See the pots that fit.'));
        potRow.appendChild(potTxt);
        var choose = mk('button', 'tw-added__add', 'Choose a pot');
        choose.type = 'button';
        choose.addEventListener('click', function () { potFor(it.key); });
        potRow.appendChild(choose);
        parts.extras.appendChild(potRow);
        parts.extras.hidden = false;
        return;
      }
      if (!missed.length) return;                              // the add-ons below belong to a pot
      var list = missed.filter(function (a) { return !ids[a.id] && !(a.role !== 'addon' && roles[a.role]); });
      if (!list.length) return;
      parts.extras.appendChild(mk('p', 'tw-sheet__eyebrow', 'Add to this set'));
      each(list, function (a) {
        var row = mk('div', 'tw-added__extra');
        if (a.icon) { var im = doc.createElement('img'); im.alt = ''; im.loading = 'lazy'; im.width = 44; im.height = 44; im.src = a.icon; row.appendChild(im); }
        var txt = mk('span', 'tw-added__extra-t');
        txt.appendChild(mk('strong', '', a.title));
        txt.appendChild(mk('em', '', (a.price ? '+' + money(a.price) : '') + (a.option ? (a.price ? ' \u00b7 ' : '') + a.option : '')));
        row.appendChild(txt);
        var b = mk('button', 'tw-added__add', '+ Add');
        b.type = 'button';
        b.setAttribute('aria-label', 'Add ' + a.title);
        b.addEventListener('click', function () {
          if (b.disabled) return;
          b.disabled = true;
          var props = { _io_bundle_id: bid, _io_bundle_role: a.role };
          if (a.service) props._io_service_type = a.service;
          fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: a.id, quantity: it.quantity || 1, properties: props }] }) })
            .then(function (r) { if (!r.ok) throw new Error('not added'); return r.json(); })
            .then(function () {
              missed = missed.filter(function (m) { return m !== a; });
              try { doc.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
              // the plant line of the set says whether repotting / a tray belong to it: keep it in step (cart script)
              var sync = window.cv3CartDrawer && window.cv3CartDrawer.syncSet ? window.cv3CartDrawer.syncSet(bid) : null;
              return sync && sync.then ? sync.then(getCart, getCart) : getCart();
            })
            .then(function (fresh) {
              if (!fresh) return;
              var again = null;
              each(fresh.items, function (i) { if (!again && i.key === it.key) again = i; });
              paintItem(again || it, '', fresh);
              paintExtras(again || it, fresh);
              paintCart(fresh);
            })
            .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
        });
        row.appendChild(b);
        parts.extras.appendChild(row);
      });
      parts.extras.hidden = false;
    }
    // for products the plant cluster has nothing for (planters, care, decor): the store's own related products
    function related(productId, inCart) {
      return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var out = [];
          each((d && d.products) || [], function (p) {
            if (out.length >= 9 || !p.available || inCart.indexOf(p.handle) > -1) return;
            var img = p.featured_image || '';
            if (img && typeof img === 'object') img = img.url || img.src || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
            var one = p.variants && p.variants.length === 1 && p.variants[0].available ? p.variants[0].id : null;
            out.push({ handle: p.handle, title: p.title, price: p.price, img: img, url: p.url || ('/products/' + p.handle), variant: one });
          });
          return out;
        })
        .catch(function () { return []; });
    }
    // Open the cart on the pot chooser for one line: the cart's own "+ Add a pot" for that plant, pressed for the shopper.
    function potFor(key) {
      if (sheetApi) sheetApi.hide();
      if (!(window.cv3CartDrawer && typeof window.cv3CartDrawer.open === 'function')) { window.location.href = '/cart'; return; }
      window.cv3CartDrawer.open();
      var tries = 0;
      (function look() {
        var b = doc.querySelector('[data-cv3-cd] [data-cv3-cd-change-pot="' + key + '"]');
        if (b) { b.click(); return; }
        if (tries++ < 24) setTimeout(look, 300);
      })();
    }
    var REFRESH = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></svg>';
    var more = { list: [], page: 0, words: null };
    function card(x) {
      var li = mk('li');
      var a = mk('a', 'tw-added__pic');
      a.href = x.url || ('/products/' + x.handle);
      if (x.img) { var im = doc.createElement('img'); im.alt = ''; im.loading = 'lazy'; im.src = x.img; a.appendChild(im); }
      li.appendChild(a);
      li.appendChild(mk('span', 'tw-added__t', x.title));
      li.appendChild(mk('span', 'tw-added__p', money(x.price)));
      if (!x.variant) {
        var v = mk('a', 'tw-added__add', 'View');
        v.href = a.href;
        li.appendChild(v);
        return li;
      }
      if (x.added) {
        // "Added" sits on the photo; the button becomes the next step. A plant just added arrives in its grow pot,
        // so that step is the pot (repotting follows in the pot chooser). The card keeps its height.
        var badge = mk('span', 'tw-added__badge');
        badge.innerHTML = TICK + '<span>Added</span>';
        a.appendChild(badge);
        if (x.lineKey && x.potColl) {
          var pot = mk('button', 'tw-added__add tw-added__add--pot', '+ Add a pot');
          pot.type = 'button';
          pot.addEventListener('click', function () { potFor(x.lineKey); });
          li.appendChild(pot);
        } else {
          var done = mk('span', 'tw-added__add is-done');
          done.innerHTML = TICK + '<span>Added</span>';
          li.appendChild(done);
        }
        return li;
      }
      var b = mk('button', 'tw-added__add', '+ Add');
      b.type = 'button';
      b.setAttribute('aria-label', 'Add ' + x.title + ' to cart');
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.disabled = true;
        var it = { id: x.variant, quantity: 1 }, props = potReady(x);
        if (props) it.properties = props;
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [it] }) })
          .then(function (r) { if (!r.ok) throw new Error('not added'); return r.json(); })
          .then(function (res) {
            x.added = true;
            x.lineKey = res && res.items && res.items[0] ? res.items[0].key : ((res && res.key) || '');
            paintGrid();
            try { doc.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
            getCart().then(paintCart);
          })
          .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
      });
      li.appendChild(b);
      return li;
    }
    // three suggestions at a time, so every Add button is in view; "Show more" turns to the next three
    function paintGrid() {
      var per = 3, pages = Math.ceil(more.list.length / per);
      parts.more.textContent = '';
      parts.more.hidden = !more.list.length;
      if (!more.list.length) return;
      if (more.words.eyebrow) parts.more.appendChild(mk('p', 'tw-sheet__eyebrow', more.words.eyebrow));
      parts.more.appendChild(mk('h2', 'tw-added__h', more.words.heading));
      var grid = mk('ul', 'tw-added__grid');
      each(more.list.slice(more.page * per, more.page * per + per), function (x) { grid.appendChild(card(x)); });
      parts.more.appendChild(grid);
      if (pages > 1) {
        var again = mk('button', 'tw-added__again');
        again.type = 'button';
        again.innerHTML = REFRESH + '<span>Show more</span>';
        again.addEventListener('click', function () { more.page = (more.page + 1) % pages; paintGrid(); });
        parts.more.appendChild(again);
      }
      if (more.words.note) parts.more.appendChild(mk('p', 'tw-added__note', more.words.note));
    }
    function paintMore(found, words) {
      more = { list: found, page: 0, words: words };
      paintGrid();
    }
    function clusterWords(sec) {
      function words(sel, fallback) { var n = sec.querySelector(sel); return (n && n.textContent.replace(/\s+/g, ' ').trim()) || fallback; }
      return { eyebrow: words('.tw-eyebrow', 'Goes well together'), heading: words('.tw-h2', 'Plants look best in clusters'), note: words('.tw-cluster__note', '') };
    }
    var lastShown = 0;
    function isOpen() { return !!sheet && sheet.classList.contains('is-open'); }
    // snippets/pot-picker-widget.liquid leaves the cart shut while this is up; forget() drops the memory of a tap on
    // the page's Add to cart button, for an add that comes from somewhere else (the plant cluster)
    window.cro2610Added = { isOpen: isOpen, forget: function () { intentUntil = 0; intentForm = null; } };
    function onAdded(form) {
      if (!sheetApi) return;
      if (!sheet) build();
      lastShown = Date.now();
      intentUntil = 0;                                   // one sheet per tap, whichever way the add was noticed
      var idInput = (form ? form.querySelector('[name="id"]') : null) || doc.querySelector('.formVariantId');
      var vid = idInput ? String(idInput.value) : '';
      var h1 = doc.querySelector('h1');
      paintItem(null, h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '');
      parts.ship.hidden = true;
      parts.more.hidden = true;
      parts.extras.hidden = true;
      parts.cart.textContent = 'View cart';
      missed = readAddOns();
      sheetApi.show(sheet, doc.activeElement, null);
      getCart().then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var it = null;
        each(cart.items, function (i) { if (!it && String(i.variant_id) === vid) it = i; });
        it = it || cart.items[0];
        paintItem(it, '', cart);
        paintExtras(it, cart);
        paintCart(cart);
        var inCart = cart.items.map(function (i) { return i.handle; });
        clusterFor(it.handle)
          .then(function (sec) { return sec ? companions(sec, 9, inCart).then(function (found) { return { sec: sec, found: found }; }) : { sec: null, found: [] }; })
          .then(function (r) {
            if (r.found.length) { paintMore(r.found, clusterWords(r.sec)); return; }
            related(it.product_id, inCart).then(function (found) { paintMore(found, { eyebrow: '', heading: 'You might also like', note: '' }); });
          });
      });
    }
    // The cart drawer opens itself after every add. When the add came from this page's own Add to cart button, the
    // sheet takes that place (the drawer asks first, see cv3-cart-drawer.js) and "View cart" opens the drawer. An app's
    // offer popup may sit between the tap and the add, so the tap is remembered for a while.
    var intentUntil = 0, intentForm = null;
    doc.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.js-ajax-submit, #pot-widget-add-all') : null;
      if (b) { intentUntil = Date.now() + 90000; intentForm = b.closest('form'); }
    }, true);
    doc.addEventListener('cv3:cart-drawer:auto-open', function (e) {
      if (isOpen()) { e.preventDefault(); return; }                       // plants added from inside the sheet stay in the sheet
      if (Date.now() < intentUntil) { e.preventDefault(); intentUntil = 0; onAdded(intentForm); }
    });
    // Fallback for an add the drawer did not see: the theme's own line appearing means the add went through.
    each(notes, function (note) {
      var shown = false;
      new MutationObserver(function () {
        var now = note.style.display !== 'none' && note.style.display !== '';
        var drawer = doc.querySelector('[data-cv3-cd]');
        if (now && !shown && Date.now() - lastShown > 8000 && !(drawer && drawer.classList.contains('is-open'))) onAdded(note.closest ? note.closest('form') : null);
        shown = now;
      }).observe(note, { attributes: true, attributeFilter: ['style'] });
    });
  }

  // ---------------------------------------------------------------- cart drawer: companions for the plant just added
  // The cart drawer already has an "Add to your order" strip with one-tap cards. Right after a plant goes
  // in the cart is when a companion is most welcome, so this puts up to two companion plants at the front
  // of that strip, using the drawer's own card markup so its own add button, feedback and refresh do the work.
  // Companions come from the same rules as the plant cluster section, asked for the newest plant in the cart.
  function drawerCompanions() {
    var wrap = doc.querySelector('[data-cv3-cd-upsell]');
    var strip = doc.querySelector('[data-cv3-cd-upsell-strip]');
    var drawer = doc.querySelector('[data-cv3-cd]');
    if (!wrap || !strip) return;
    var head = wrap.querySelector('.cv3-cd__upsell-head-text');
    var headWas = head ? head.textContent : '';
    var sectionCache = {};
    var running = false, again = false;
    var last = null;                       // what is showing now: { found: [...], title: '...' }, so a redraw of the strip can be repaired
    function wipe() { each(strip.querySelectorAll('[data-cro2610-companion]'), function (c) { c.parentNode.removeChild(c); }); }
    function clear() {
      last = null;
      wipe();
      if (head && headWas && head.textContent !== headWas) head.textContent = headWas;
    }
    function put() {
      if (!last) return;
      wipe();
      for (var k = last.found.length - 1; k >= 0; k--) strip.insertBefore(card(last.found[k]), strip.firstChild);
      if (head && head.textContent !== last.title) head.textContent = last.title;
      if (wrap.hidden) wrap.hidden = false;
      if (strip.scrollLeft) strip.scrollLeft = 0;
    }
    function sectionFor(handle) {
      if (!sectionCache[handle]) {
        sectionCache[handle] = fetch('/products/' + handle + '?section_id=cro2610-plant-cluster', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) { var box = doc.createElement('div'); box.innerHTML = html; return box.querySelector('[data-tw-cluster]'); })
          .catch(function () { return null; });
      }
      return sectionCache[handle];
    }
    function card(x) {
      var c = doc.createElement('div');
      c.className = 'cv3-cd__upsell-card';
      c.setAttribute('role', 'button');
      c.setAttribute('tabindex', '0');
      c.setAttribute('data-cv3-cd-upsell-add', x.variant);
      c.setAttribute('data-cv3-cd-upsell-handle', x.handle);
      c.setAttribute('data-cro2610-companion', '');
      var props = potReady(x);
      if (props) c.setAttribute('data-cv3-cd-upsell-props', JSON.stringify(props));
      c.setAttribute('aria-label', 'Add ' + x.title + ' to cart');
      var im = doc.createElement('span'); im.className = 'cv3-cd__upsell-img';
      if (x.img) { var i = doc.createElement('img'); i.src = x.img; i.alt = ''; i.loading = 'lazy'; i.width = 80; i.height = 80; im.appendChild(i); }
      var n = doc.createElement('span'); n.className = 'cv3-cd__upsell-name'; n.textContent = x.title;
      var p = doc.createElement('span'); p.className = 'cv3-cd__upsell-price'; p.textContent = money(x.price);
      var plus = doc.createElement('span'); plus.className = 'cv3-cd__upsell-plus'; plus.setAttribute('aria-hidden', 'true'); plus.textContent = '+';
      c.appendChild(im); c.appendChild(n); c.appendChild(p); c.appendChild(plus);
      return c;
    }
    function run() {
      if (running) { again = true; return; }
      running = true;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items || !cart.items.length) { clear(); return null; }
          var plant = null, inCart = [];
          each(cart.items, function (it) {
            inCart.push(it.handle);
            if (!plant && /potted plant/i.test(it.product_type || '')) plant = it;   // newest line comes first
          });
          if (!plant) { clear(); return null; }
          return sectionFor(plant.handle).then(function (sec) {
            if (!sec) { clear(); return; }
            return companions(sec, 2, inCart).then(function (found) {
              if (!found.length) { clear(); return; }
              var name = plant.product_title || '';
              last = { found: found, title: 'Goes well with your ' + (name && name.length <= 22 ? name : 'new plant') };
              put();
            });
          });
        })
        .catch(function () {})
        .then(function () { running = false; if (again) { again = false; run(); } });
    }
    doc.addEventListener('cart:updated', function () { setTimeout(run, 350); });
    // The drawer redraws this strip by itself after each cart change, which would drop the companions again.
    if ('MutationObserver' in window) {
      var fix = 0;
      new MutationObserver(function () {
        if (!last || fix) return;
        if (strip.querySelector('[data-cro2610-companion]') && (!head || head.textContent === last.title)) return;
        fix = setTimeout(function () { fix = 0; if (last && (!strip.querySelector('[data-cro2610-companion]') || (head && head.textContent !== last.title))) put(); }, 60);
      }).observe(wrap, { childList: true, subtree: true, characterData: true });
    }
    if (drawer && 'MutationObserver' in window) {
      var wasOpen = drawer.classList.contains('is-open');
      new MutationObserver(function () {
        var open = drawer.classList.contains('is-open');
        if (open && !wasOpen) run();
        wasOpen = open;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // ---------------------------------------------------------------- cart page: add-ons shelf, checkout bar on phones, long carts
  // sections/cro2610-cart-addons.liquid prints the shelf; here it moves to sit under the cart items and gets its
  // behaviour. The cart re-renders its own lines after every change (assets/cv3-cart-drawer.js). Nothing here asks
  // Shopify for the cart again: what is in the cart and the total are read from the page.
  function cartPage() {
    var page = doc.querySelector('[data-cv3-cd-page]');
    var main = page && page.querySelector('.cv3-cp__main');
    if (!main) return;
    var root = doc.documentElement;
    var shelf = null, shelves = [], bar = null, more = null, foldCss = null, folded = true;   // shelf = the first one: its settings drive the phone layout
    function mk(tag, cls, text) { var n = doc.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
    function totalText() {
      var el = page.querySelector('.cv3-cp__summary-row--total span:last-child');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    // free delivery is counted on the total after all discounts: the figure in the summary's Total row
    function ship() {
      var total = parseFloat(totalText().replace(/[^0-9.]/g, ''));
      if (!shelf || isNaN(total)) return null;
      return shipState(shelf, { item_count: 1, total_price: Math.round(total * 100) });
    }
    function inCart() {
      var ids = {};
      each(page.querySelectorAll('[data-cv3-cp-flat-list] [data-cv3-cd-key]'), function (li) {
        ids[(li.getAttribute('data-cv3-cd-key') || '').split(':')[0]] = true;
      });
      return ids;
    }
    function chosen(card) {
      var sel = card.querySelector('[data-tw-cartadd-variant]'), btn = card.querySelector('[data-tw-cartadd-add]');
      return sel ? sel.value : (btn ? btn.getAttribute('data-tw-cartadd-add') : '');
    }
    function label(btn, text) { var t = btn.querySelector('span'); if (t) t.textContent = text; }

    // Long carts: only the last few cards show, the earlier ones fold behind one button above them. The cart lists
    // its lines oldest first, so what was added last, and anything added from the shelf, stays in view next to the
    // shelf. One style rule does the hiding, so it keeps working when the cart swaps its lines.
    function fold() {
      var n = shelf ? parseInt(shelf.getAttribute('data-collapse'), 10) || 0 : 0;
      if (!n) return;
      var flat = root.getAttribute('data-cv3-cart-view') === 'flat';
      var first = page.querySelector('[data-cv3-cp-bundled-list]');
      var list = flat ? page.querySelector('[data-cv3-cp-flat-list]') : first;
      var hide = (list ? list.children.length : 0) - n;
      if (!first) return;
      if (!foldCss) {
        foldCss = mk('style');
        foldCss.textContent = '.cv3-cp__main.tw-cart-fold [data-cv3-cp-bundled-list] > li:nth-last-child(n+' + (n + 1) + '), .cv3-cp__main.tw-cart-fold [data-cv3-cp-flat-list] > li:nth-last-child(n+' + (n + 1) + ') { display: none !important; }';
        doc.head.appendChild(foldCss);
      }
      if (!more) {
        more = mk('div', 'tw-cartmore');
        more.appendChild(mk('button'));
        more.firstChild.type = 'button';
        more.firstChild.addEventListener('click', function () { folded = !folded; fold(); });
      }
      if (more.nextSibling !== first) first.parentNode.insertBefore(more, first);
      // folding a single line away is not worth a button; and "Itemised" is the view for seeing every line, so it never folds
      var can = hide >= 2 && !flat;
      main.classList.toggle('tw-cart-fold', can && folded);
      more.hidden = !can;
      more.firstChild.textContent = folded ? 'Show ' + hide + ' earlier items' : 'Show fewer';
    }

    function paint() {
      if (!shelf) return;
      var ids = inCart();
      each(main.querySelectorAll('[data-tw-cartadd] [data-tw-cartadd-card]'), function (card) {
        var btn = card.querySelector('[data-tw-cartadd-add]');
        if (!btn || btn.classList.contains('is-busy')) return;
        var on = !!ids[chosen(card)];
        card.classList.toggle('is-in', on);
        label(btn, on ? 'Add 1 more' : 'Add');
      });
      var st = ship(), line = shelf.querySelector('[data-tw-cartadd-ship]');
      if (line && st && st.text) { line.hidden = false; line.classList.toggle('is-done', st.done); line.querySelector('span').textContent = st.text; }
      if (bar) {
        bar.querySelector('[data-tw-cartbar-total]').textContent = totalText();
        var note = bar.querySelector('[data-tw-cartbar-ship]');
        note.textContent = st && st.text ? st.text : '';
        note.classList.toggle('is-done', !!(st && st.done));
      }
      fold();
    }

    function add(btn) {
      var card = btn.closest('[data-tw-cartadd-card]');
      var id = card ? parseInt(chosen(card), 10) : 0;
      if (!id || btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      label(btn, 'Adding');
      var old = card.querySelector('.tw-cartadd__err');
      if (old) old.parentNode.removeChild(old);
      var api = window.cv3CartDrawer;
      // the cart's own add: its lines and totals update in place, no reload
      var sent = api && api.add ? api.add({ id: id, quantity: 1 }, { quiet: true })
        : fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d && (d.description || d.message) || ''); window.location.reload(); }); });
      sent.then(function () {
        btn.classList.remove('is-busy');
        card.classList.add('is-in');
        label(btn, 'Add 1 more');
      }).catch(function (err) {
        btn.classList.remove('is-busy');
        // Shopify's own words when there is one (for example, no more stock)
        card.appendChild(mk('p', 'tw-cartadd__err', (err && err.message && err.message !== 'add failed') ? err.message : 'Could not add this. Please try again.'));
        paint();
      });
    }

    function bind(el) {
      el.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-tw-cartadd-tab]');
        if (tab) {
          var key = tab.getAttribute('data-tw-cartadd-tab');
          each(el.querySelectorAll('[data-tw-cartadd-tab]'), function (t) {
            var on = t === tab;
            t.classList.toggle('is-on', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          each(el.querySelectorAll('[data-tw-cartadd-pane]'), function (pane) {
            pane.hidden = pane.getAttribute('data-tw-cartadd-pane') !== key;
            if (!pane.hidden) pane.scrollLeft = 0;
          });
          return;
        }
        var btn = e.target.closest('[data-tw-cartadd-add]');
        if (btn) { e.preventDefault(); add(btn); }
      });
      el.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-tw-cartadd-variant]');
        if (!sel) return;
        var opt = sel.options[sel.selectedIndex], card = sel.closest('[data-tw-cartadd-card]');
        var price = card.querySelector('[data-tw-cartadd-price]'), was = card.querySelector('[data-tw-cartadd-was]');
        if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
        if (was) { was.textContent = opt.getAttribute('data-was') || ''; was.hidden = !opt.getAttribute('data-was'); }
        paint();
      });
    }

    // Phones: the total and a Checkout button stay within reach. The button brings the shopper to the delivery
    // date and the real Checkout button; it steps away once that button is on screen.
    function buildBar() {
      var real = page.querySelector('.cv3-cp__checkout');
      if (bar || !shelf || shelf.getAttribute('data-bar') !== 'true' || !real) return;
      bar = mk('div', 'tw-cartbar');
      bar.setAttribute('data-tw-cartbar', '');
      var sum = mk('div', 'tw-cartbar__sum');
      var top = mk('div', 'tw-cartbar__top');
      top.appendChild(mk('span', 'tw-cartbar__l', 'Total'));
      var total = mk('strong'); total.setAttribute('data-tw-cartbar-total', ''); top.appendChild(total);
      sum.appendChild(top);
      var note = mk('span', 'tw-cartbar__ship'); note.setAttribute('data-tw-cartbar-ship', ''); sum.appendChild(note);
      var go = mk('button', 'tw-cartbar__go', shelf.getAttribute('data-bar-label') || 'Checkout');
      go.type = 'button';
      bar.appendChild(sum); bar.appendChild(go);
      doc.body.appendChild(bar);
      root.classList.add('cro2610-cart-bar');
      go.addEventListener('click', function () {
        var target = page.querySelector('.cv3-cp__delivery') || real;
        try { target.scrollIntoView({ behavior: 'smooth', block: target === real ? 'center' : 'start' }); } catch (e) { target.scrollIntoView(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { bar.classList.toggle('is-on', !entries[0].isIntersecting); }).observe(real);
      } else {
        bar.classList.add('is-on');
      }
      // chat buttons load late and sit in the bottom right corner: the bar's button stops short of them
      each([1500, 4000, 8000, 15000], function (ms) { setTimeout(clearance, ms); });
      window.addEventListener('resize', clearance);
    }
    function clearance() {
      if (!bar) return;
      var w = window.innerWidth, h = window.innerHeight, pad = 0;
      each(doc.querySelectorAll('#delightchat-widget *, #bik-chat-root *'), function (el) {
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.width < 20 || r.width > 120 || r.height > 120) return;        // a button, not an open chat window
        if (r.bottom > h - bar.offsetHeight + 8 && r.left > w / 2) pad = Math.max(pad, w - r.left + 8);
      });
      bar.style.paddingRight = pad ? Math.round(pad) + 'px' : '';
    }

    // A tab of the type "Goes with the cart": ask the store what it recommends for up to three plants in the cart
    // (sections/cro2610-cart-recs.liquid returns ready cards) and deal them out in turn, so the row mixes what goes
    // with each. Left out: what is in the cart, and what another shelf or tab already shows. Nothing left = no tab.
    function dropTab(el, pane) {
      var key = pane.getAttribute('data-tw-cartadd-pane');
      var tab = el.querySelector('[data-tw-cartadd-tab="' + key + '"]');
      var wasOn = !pane.hidden;
      if (tab && tab.parentNode) tab.parentNode.removeChild(tab);
      if (pane.parentNode) pane.parentNode.removeChild(pane);
      var left = el.querySelectorAll('[data-tw-cartadd-pane]');
      if (!left.length) { if (el.parentNode) el.parentNode.removeChild(el); return; }
      if (wasOn) {
        left[0].hidden = false;
        var first = el.querySelector('[data-tw-cartadd-tab="' + left[0].getAttribute('data-tw-cartadd-pane') + '"]');
        if (first) { first.classList.add('is-on'); first.setAttribute('aria-selected', 'true'); }
      }
      var tabs = el.querySelector('.tw-cartadd__tabs');
      if (tabs && left.length < 2) tabs.hidden = true;
    }
    function recs(el) {
      each(el.querySelectorAll('[data-tw-cartadd-recs]'), function (pane) {
        if (pane.__twRecs) return;
        pane.__twRecs = 1;
        var ids = (pane.getAttribute('data-tw-cartadd-recs') || '').split(',').filter(function (x) { return x; }).slice(0, 3);
        var limit = parseInt(pane.getAttribute('data-limit'), 10) || 8;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var taken = {};
        each((el.getAttribute('data-in-cart') || '').split('|'), function (id) { if (id) taken[id] = true; });
        Promise.all(ids.map(function (id) {
          return fetch(base + 'recommendations/products?section_id=cro2610-cart-recs&product_id=' + encodeURIComponent(id) + '&limit=10&intent=related', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) { var box = doc.createElement('div'); box.innerHTML = html; return [].slice.call(box.querySelectorAll('[data-tw-cartadd-card]')); })
            .catch(function () { return []; });
        })).then(function (lists) {
          // what the other tabs and shelves show now (read late, so shelves mounted meanwhile count too)
          each(main.querySelectorAll('[data-tw-cartadd-card][data-product]'), function (c) { taken[c.getAttribute('data-product')] = true; });
          pane.textContent = '';
          var n = 0;
          for (var i = 0; i < 10 && n < limit; i++) {
            each(lists, function (list) {
              var card = list[i];
              if (!card || n >= limit) return;
              var pid = card.getAttribute('data-product');
              if (!pid || taken[pid]) return;
              taken[pid] = true;
              pane.appendChild(card);
              n++;
            });
          }
          if (!n) dropTab(el, pane); else paint();
        });
      });
    }

    function mount() {
      // every shelf on the page, in template order: those still in their own section, and those moved here before
      var fresh = [].slice.call(doc.querySelectorAll('.cro2610-cart-addons [data-tw-cartadd]'));
      if (!fresh.length && !main.querySelector('[data-tw-cartadd]')) fresh = [].slice.call(doc.querySelectorAll('[data-tw-cartadd]'));
      // the theme editor re-renders a section in its own place: drop the copy of that section moved earlier
      var again = {};
      each(fresh, function (el) { again[el.getAttribute('data-section') || ''] = true; });
      each(main.querySelectorAll('[data-tw-cartadd]'), function (el) {
        if (fresh.indexOf(el) === -1 && again[el.getAttribute('data-section') || '']) el.parentNode.removeChild(el);
      });
      each(fresh, function (el) {
        if (!el.__twBound) { el.__twBound = 1; bind(el); }
        main.appendChild(el);
      });
      shelves = [].slice.call(main.querySelectorAll('[data-tw-cartadd]'));
      if (!shelves.length) return;
      shelf = shelves[0];
      each(shelves, recs);
      buildBar();
      paint();
    }
    mount();
    doc.addEventListener('cv3:cart-page-soft-reloaded', paint);
    doc.addEventListener('shopify:section:load', mount);
    // the Combined / Itemised switch shows the other list: count that one
    doc.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-cv3-cp-view]')) setTimeout(fold, 0); });
  }

  // ---------------------------------------------------------------- header: the cart count follows the cart
  // The header prints the count when the page is built; nothing changed it after an add or an edit, so it stayed
  // on the old number until the next page. The read is shared with everything else that asks after a change.
  function cartCount() {
    if (!doc.querySelector('.cart-count-bubble')) return;
    var wait = 0;
    function paint(n) {
      each(doc.querySelectorAll('.cart-count-bubble'), function (bubble) {
        var span = bubble.querySelector('span');
        if (n >= 100) { if (span) span.parentNode.removeChild(span); return; }   // the header leaves 100+ blank
        if (!span) { span = doc.createElement('span'); span.setAttribute('aria-hidden', 'true'); bubble.appendChild(span); }
        span.textContent = '(' + n + ')';
      });
    }
    doc.addEventListener('cart:updated', function () {
      clearTimeout(wait);
      wait = setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) { if (cart && typeof cart.item_count === 'number') paint(cart.item_count); })
          .catch(function () {});
      }, 700);
    });
  }

  // ---------------------------------------------------------------- product page: total inside the buy button
  // Covers both buttons: the normal add to cart, and the "plant + pot" one the theme swaps in once a pot is chosen.
  function atcTotal() {
    if (!doc.documentElement.classList.contains('cro2610-atc-total')) return;
    var btn = doc.getElementById('addToCart');
    if (!btn || btn.tagName !== 'INPUT') return;
    var plain = btn.value;
    if (!/add to (cart|bag|basket)/i.test(plain)) return;
    var mine = '', potMine = '';
    function amount() {
      var total = doc.querySelector('[data-cv3-total-card] [data-cv3-total]');
      var a = total ? total.textContent.replace(/\s+/g, '').replace(/\.00$/, '') : '';
      return /^\$?\d/.test(a) ? a : '';
    }
    function paint() {
      var a = amount();
      var cur = btn.value;
      if (a && (cur === mine || (!btn.disabled && /^\s*add to (cart|bag|basket)\s*$/i.test(cur.replace(/\s*·.*$/, ''))))) {
        if (cur !== mine) plain = cur.replace(/\s*·.*$/, '');
        mine = plain + ' · ' + a;
        if (btn.value !== mine) btn.value = mine;
      }
      var pot = doc.getElementById('pot-widget-add-all');
      if (!pot) return;
      var t = pot.textContent.replace(/\s+/g, ' ').trim();
      if (a && (t === potMine || /^add plant \+ pot/i.test(t))) {
        potMine = 'Add plant + pot · ' + a;
        if (t !== potMine) pot.textContent = potMine;
      }
    }
    paint();
    setInterval(paint, 500);
  }

  // ---------------------------------------------------------------- product page: even spacing in the buy box
  // The buy box is a column with a fixed gap between blocks. Blocks that draw nothing (an app with nothing to show
  // for this product, a style-only block) still take a gap each, which leaves uneven holes. Those get the class
  // tw-nogap (cro2610.css pulls them up by one gap); the class comes off again the moment a block shows something.
  function evenGaps() {
    if (!doc.documentElement.classList.contains('cro2610-buybox')) return;
    var col = doc.querySelector('.product__section-content');
    if (!col || !('ResizeObserver' in window)) return;
    var ro = new ResizeObserver(function (entries) {
      each(entries, function (en) { en.target.classList.toggle('tw-nogap', en.target.offsetHeight === 0 && en.target.id !== 'pot-widget-add-all'); });
    });
    function watch() { each(col.children, function (el) { if (!el.__twGap && !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) { el.__twGap = 1; ro.observe(el); } }); }
    watch();
    if ('MutationObserver' in window) new MutationObserver(watch).observe(col, { childList: true });
  }

  // ---------------------------------------------------------------- product page: pot picker polish
  // Display only. Adds each suggested pot's colour under its name (two suggestions are often the same pot in two
  // colours), makes the "view all" tile quote the same number as the chooser, and hides the "Learn more" link when
  // the part of the page it jumps to is not on this template. Choosing, pricing and adding stay with the theme.
  function potPolish() {
    if (!doc.documentElement.classList.contains('cro2610-buybox')) return;
    var w = doc.getElementById('pot-widget');
    if (!w) return;
    var learn = w.querySelector('.pot-offer a[href^="#"]');
    if (learn) {
      var target = learn.getAttribute('href').slice(1);
      if (!target || !doc.getElementById(target)) w.classList.add('tw-nolearn');
    }
    function dress() {
      var modal = doc.getElementById('pots-modal');
      if (!modal) return;
      var n = 0;
      each(modal.querySelectorAll('.pots-grid .pot-option[data-variant-id]'), function (t) { if (t.getAttribute('data-variant-id')) n++; });
      each(w.querySelectorAll('.pots-inline .pot-option[data-variant-id]'), function (t) {
        var id = t.getAttribute('data-variant-id');
        if (!id || t.querySelector('.tw-pot-sub')) return;
        var twin = modal.querySelector('.pots-grid .pot-option[data-variant-id="' + id + '"] .variant');
        var txt = twin ? twin.textContent.replace(/\s+/g, ' ').trim() : '';
        // "eclipse - gray" → "Gray": on a small tile the colour is the part that tells two pots apart
        var bits = txt.split(' / ')[0].split(' - ');
        txt = (bits.length > 1 ? bits.slice(1).join(' - ') : bits[0]).trim();
        if (!txt) return;
        txt = txt.charAt(0).toUpperCase() + txt.slice(1);
        var sub = doc.createElement('div');
        sub.className = 'tw-pot-sub';
        sub.textContent = txt;
        t.appendChild(sub);
      });
      var label = w.querySelector('.pot-option.see-all .label');
      if (label && n >= 20 && /^view\b/i.test(label.textContent.trim())) {
        var want = 'View ' + (Math.floor(n / 10) * 10) + '+ pots';
        if (label.textContent.trim() !== want) label.textContent = want;
      }
    }
    dress();
    setTimeout(dress, 1200);   // the theme sets its own label once the page has loaded
    if (window.cv3PotGrid) window.cv3PotGrid.ready(dress);   // the full list can arrive after the page: count and colours need it
    if ('MutationObserver' in window) new MutationObserver(dress).observe(w, { childList: true });   // tiles come back when a pot is removed
  }

  // ---------------------------------------------------------------- product page: photo of the chosen option beside the picker
  // On a phone the big photo is a screen or more above the size / colour buttons, so the shopper cannot see it change.
  // This keeps a small photo of the chosen option right at the picker (inside the "Plant size" card when there is one)
  // and swaps it the moment another option is chosen. Tapping it goes back up to the big photo.
  function optionPhoto() {
    if (!doc.documentElement.classList.contains('cro2610-buybox')) return;
    var picker = doc.querySelector('.product__section-content__block--variant_picker');
    var json = doc.querySelector('script.product-json');
    if (!picker || !json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    var variants = (product && product.variants) || [];
    if (variants.length < 2) return;
    function src(v) { var f = v && v.featured_image; return f ? (f.src || f.url || '') : ''; }
    var any = false;
    each(variants, function (v) { if (src(v)) any = true; });
    if (!any) return;
    function sized(u) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=240') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240'; }
    var btn = doc.createElement('button');
    btn.type = 'button';
    btn.className = 'tw-optphoto__img';
    btn.setAttribute('aria-label', 'See this photo larger');
    var img = doc.createElement('img');
    img.alt = ''; img.width = 84; img.height = 84;
    btn.appendChild(img);
    var cap = null;
    var glance = doc.querySelector('.product__section-content .tw-size-glance');
    if (glance) {
      glance.classList.add('tw-size-glance--photo');
      glance.insertBefore(btn, glance.firstChild);
    } else {
      var box = doc.createElement('div');
      box.className = 'tw-optphoto';
      var txt = doc.createElement('span');
      txt.className = 'tw-optphoto__txt';
      var small = doc.createElement('span'); small.textContent = 'Your choice';
      cap = doc.createElement('strong');
      txt.appendChild(small); txt.appendChild(cap);
      box.appendChild(btn); box.appendChild(txt);
      picker.parentNode.insertBefore(box, picker.nextSibling);
    }
    btn.addEventListener('click', function () {
      var g = doc.querySelector('#slider') || doc.querySelector('.product__section-images');
      if (g && g.scrollIntoView) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    function current() {
      var id = '';
      try { id = new URL(window.location.href).searchParams.get('variant') || ''; } catch (e) {}
      var f = doc.querySelector('.product__section-content .formVariantId');
      if (!id && f) id = f.value;
      var found = null;
      each(variants, function (v) { if (String(v.id) === String(id)) found = v; });
      return found || variants[0];
    }
    var last = '';
    function paint() {
      var v = current();
      var u = src(v);
      if (cap) cap.textContent = v.title || '';
      if (!u) return;
      u = sized(u);
      if (u === last) return;
      var first = !last;
      last = u;
      img.src = u;
      if (!first) { btn.classList.remove('is-new'); void btn.offsetWidth; btn.classList.add('is-new'); }
    }
    paint();
    doc.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product__section-content')) { setTimeout(paint, 80); setTimeout(paint, 500); }
    });
  }

  // ---------------------------------------------------------------- product page: relatives of this plant
  // Fills the plant family section with the other products that carry the same family tag. Fetched once the section
  // is near the screen; the section stays hidden when the product has neither a family note nor relatives.
  function family(el) {
    var tag = el.getAttribute('data-tag') || '';
    var rail = el.querySelector('[data-tw-family-rail]');
    if (!tag || !rail) return;
    var max = parseInt(el.getAttribute('data-max'), 10) || 6;
    var skip = el.getAttribute('data-exclude') || '';
    var done = false;
    function load() {
      if (done) return;
      done = true;
      fetch((el.getAttribute('data-url') || '/collections/all') + '/' + encodeURIComponent(tag) + '?filter.v.availability=1&section_id=cro2610-picks', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var box = doc.createElement('div');
          box.innerHTML = html;
          var n = 0;
          each(box.querySelectorAll('.tw-pick'), function (p) {
            var card = p.querySelector('.tw-card');
            if (!card || n >= max || p.getAttribute('data-handle') === skip || p.getAttribute('data-available') !== 'true') return;
            each(card.querySelectorAll('a[href]'), function (a) { a.setAttribute('href', withView(a.getAttribute('href'))); });
            rail.appendChild(card);
            n++;
          });
          if (n) el.hidden = false;
        })
        .catch(function () {});
    }
    if (el.hidden || !('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  // ---------------------------------------------------------------- header: the phone menu
  // Switched on by the "Use the new phone menu" setting of the Header 13 section (it sets html.cro2610-menu).
  // The menu's own script still opens, closes and switches category; this reshapes what it shows.
  //   First screen: offer line, search, two photo cards (shop, plant styling), the categories as rows with a photo
  //                 each, then a slim bar of four buttons (account, rewards, AI studio, support) and help links.
  //   In a category: a way back, its links shown at once as grouped buttons (no second tap), then its featured photos.
  /* Product page, phones and tablets: a bar at the bottom that keeps the way to buy in reach on a long page.
     It never adds to the cart by itself on a product with choices: it shows the name and the current price and
     its button takes the shopper to the size and pot choices (before they have been seen) or back to the page's
     own buy button (after). Only a product with nothing to choose gets a button that presses the page's own
     Add to Cart. The bar is off while the choices or the buy button are on screen, and while the menu, the cart
     drawer, the pot chooser or a sheet is open (rules in cro2610.css). */
  function buyBar() {
    try {
      if (!document.body || !/\btemplate-product\b/.test(document.body.className)) return;
      var main = document.getElementById('addToCart');
      if (!main || document.querySelector('.tw-buybar')) return;
      var steps = document.querySelectorAll('.cro-step');
      var picker = document.querySelector('[class*="product__section-content__block--variant_picker"]');
      var start = steps[0] || (picker && picker.offsetHeight > 0 ? picker : null);
      var title = document.querySelector('h1.cv3__title') || document.querySelector('h1');
      var bar = document.createElement('div');
      bar.className = 'tw-buybar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Buy this product');
      bar.innerHTML = '<div class="tw-buybar__txt"><b></b><span></span></div><button type="button" class="tw-buybar__btn"></button>';
      var name = bar.querySelector('b'), price = bar.querySelector('span'), btn = bar.querySelector('button');
      name.textContent = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
      document.body.appendChild(bar);
      var seen = false, queued = false;
      var liveBtn = function () { var p = document.getElementById('pot-widget-add-all'); return p && p.offsetParent !== null ? p : main; };
      var money = function () {
        var b = liveBtn(), m = String(b.value || b.textContent || '').match(/\$\s?[\d.,]*\d/);
        if (!m) { var pr = document.querySelector('.cv3__price'); m = pr ? pr.textContent.match(/\$\s?[\d.,]*\d/) : null; }
        return m ? m[0].replace(/\s/g, '') : '';
      };
      // 2026-10-30 members-only sale: visitors also see the member price ("$18 · Members $13.50"), only while the
      // price shown is the plant's own price (not a total with a pot added)
      var num = function (s) { return parseFloat(String(s || '').replace(/[^\d.]/g, '')) || 0; };
      var paint = function () {
        var m = money(), mp = document.querySelector('.tw-mb [data-tw-sp-final]'), now = document.querySelector('[data-cv3-price-now]');
        price.textContent = (mp && now && m && num(m) === num(now.textContent)) ? m + ' · Members ' + mp.textContent.trim() : m;
        btn.textContent = !start ? 'Add to cart' : (seen ? 'Review & add' : (steps.length > 1 ? 'Choose size & pot' : 'Choose options'));
      };
      var upd = function () {
        queued = false;
        // a booking product swaps the page's own button for the booking app's: no bar there
        var lb = liveBtn();
        if (!document.documentElement.contains(lb) || lb.getClientRects().length === 0) { bar.classList.remove('is-on'); document.documentElement.classList.remove('tw-buybar-on'); return; }
        var vh = window.innerHeight, a = (start || main).getBoundingClientRect(), b = liveBtn().getBoundingClientRect();
        if (b.top < vh && b.bottom > 0) seen = true;
        var inZone = a.top < vh - 90 && b.bottom > 70;
        bar.classList.toggle('is-on', !inZone);
        document.documentElement.classList.toggle('tw-buybar-on', !inZone);
        paint();
      };
      var ask = function () { if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(upd); };
      btn.addEventListener('click', function () {
        if (!start) { liveBtn().click(); return; }
        var to = seen ? liveBtn() : start;
        to.scrollIntoView({ behavior: 'smooth', block: seen ? 'center' : 'start' });
      });
      window.addEventListener('scroll', ask, { passive: true });
      window.addEventListener('resize', ask);
      document.addEventListener('change', function () { setTimeout(ask, 300); });
      document.addEventListener('click', function () { setTimeout(ask, 400); });
      upd();
      // apps finish drawing after the page has loaded (prices, the booking app's own button): look again
      setTimeout(ask, 1500);
      setTimeout(ask, 4500);
    } catch (e) {}
  }

  function phoneMenu() {
    var html = doc.documentElement;
    if (!html.classList.contains('cro2610-menu')) return;
    var inner = doc.querySelector('[class*="header-menu-mobile-inner-"]');
    if (!inner || inner.__twMenu) return;
    var panel = inner.parentNode;
    var toggles = inner.querySelector('[class*="header-menu-mobile-toggles-"]');
    var tabs = inner.querySelector('[class*="header-menu-mobile-tabs-"]');
    if (!toggles || !tabs) return;
    inner.__twMenu = 1;
    panel.classList.add('tw-mm');
    var top = toggles.parentNode;
    var was = false, closingUntil = 0;
    var WHATSAPP = 'https://wa.me/6580561106';
    function svg(d, size) { return '<svg viewBox="0 0 24 24" width="' + (size || 22) + '" height="' + (size || 22) + '" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
    var ARROW = svg('<path d="M9 6l6 6-6 6"/>', 20);
    var GO = svg('<path d="M5 12h14M13 6l6 6-6 6"/>', 18);
    var ICON = {
      person: '<circle cx="12" cy="8.2" r="3.7"/><path d="M4.6 20c.8-3.7 3.8-5.7 7.4-5.7s6.6 2 7.4 5.7"/>',
      gift: '<path d="M4.5 11h15v8.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1z"/><path d="M3.5 7.5h17V11h-17zM12 7.5v13"/><path d="M12 7.5c-.6-2.4-2.2-4-3.8-4-1.2 0-2 .8-2 1.9 0 1.3 1.2 2.1 2.8 2.1zM12 7.5c.6-2.4 2.2-4 3.8-4 1.2 0 2 .8 2 1.9 0 1.3-1.2 2.1-2.8 2.1z"/>',
      spark: '<path d="M11 3.5l1.9 5.2 5.2 1.9-5.2 1.9L11 17.7l-1.9-5.2-5.2-1.9 5.2-1.9z"/><path d="M18.3 15.3l.8 2.1 2.1.8-2.1.8-.8 2.1-.8-2.1-2.1-.8 2.1-.8z"/>',
      chat: '<path d="M5 4.8h14a1.7 1.7 0 0 1 1.7 1.7v8.3a1.7 1.7 0 0 1-1.7 1.7h-6.8l-4.5 3.7v-3.7H5a1.7 1.7 0 0 1-1.7-1.7V6.5A1.7 1.7 0 0 1 5 4.8z"/><path d="M8.5 10.7h.01M12 10.7h.01M15.5 10.7h.01"/>',
      ig: '<rect x="4" y="4" width="16" height="16" rx="4.5"/><circle cx="12" cy="12" r="3.6"/><path d="M16.7 7.3h.01"/>',
      fb: '<rect x="4" y="4" width="16" height="16" rx="4.5"/><path d="M15 8h-1.3c-1 0-1.7.7-1.7 1.7V20M9.5 13h5"/>'
    };
    function make(tag, cls, text) { var n = doc.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
    function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
    function titled(s) { return clean(s).toLowerCase().replace(/(^|\s)\S/g, function (m) { return m.toUpperCase(); }); }
    function nice(s) { s = clean(s); return s === s.toUpperCase() ? titled(s) : s; }
    function real(h) { return !!h && h !== '#' && !/^javascript:/i.test(h); }
    function sized(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function picOf(box) {
      var im = box ? box.querySelector('img') : null;
      var s = im ? (im.getAttribute('src') || '') : '';
      if (im && (!s || s.indexOf('data:') === 0)) s = im.getAttribute('data-src') || '';
      return s;
    }
    var spotSrc = doc.querySelector('[data-tw-mm-spot]');
    function set(n) { return spotSrc ? (spotSrc.getAttribute('data-' + n) || '') : ''; }
    function root() { panel.classList.remove('tw-mm-sub'); inner.scrollTop = 0; }
    function closeMenu() {
      var x = panel.querySelector('button[class*="header-menu-burger-"]');
      if (x) x.click();
      closingUntil = Date.now() + 700;
      was = false;
      html.classList.remove('tw-mm-open');
    }
    // close the menu, then open something that sits on top of the page (search)
    function then(fn) { return function (e) { if (e) e.preventDefault(); closeMenu(); setTimeout(fn, 300); }; }

    // ---- inside a category: its links as grouped buttons
    function linksIn(box) {
      var out = [], seen = {};
      each(box.querySelectorAll('a[class*="header-menu-link-"]'), function (a) {
        var h = a.getAttribute('href'), t = clean(a.textContent), key = h + '|' + t.toLowerCase();
        if (!t || !real(h) || seen[key]) return;
        seen[key] = 1;
        out.push({ text: t, href: h });
      });
      return out;
    }
    function readGroups(list) {
      var groups = [], loose = null;
      each(list.children, function (li) {
        var sub = null;
        each(li.children, function (c) { if (/header-mobile-submenu-/.test(String(c.className))) sub = c; });
        var a = li.querySelector('a[class*="header-menu-link-"]');
        if (!a) return;
        var t = clean(a.textContent), h = a.getAttribute('href');
        if (!sub) {
          if (!t || !real(h)) return;
          if (!loose) { loose = { title: '', href: '', links: [] }; groups.push(loose); }
          loose.links.push({ text: t, href: h });
          return;
        }
        loose = null;
        var g = { title: t, href: real(h) ? h : '', links: linksIn(sub) };
        // as the menu's own drill-down does: a parent with its own page gets a "Shop all" link when none of its links goes there
        if (g.href && !g.links.some(function (l) { return l.href === g.href; })) g.links.unshift({ text: 'Shop all ' + t, href: g.href });
        groups.push(g);
      });
      return groups;
    }
    // the category's own "all" link, when it starts with one (All Plants, All Planters, Shop All Gifts), becomes a bar at the top
    function allLink(groups, tiles) {
      var c = [], g = groups[0];
      if (g && g.href) c.push({ text: g.title, href: g.href });
      if (g && g.links[0]) c.push(g.links[0]);
      var t = tiles ? tiles.querySelector('a[class*="header-submenu-collection-"]') : null;
      if (t && real(t.getAttribute('href'))) c.push({ text: nice(t.textContent), href: t.getAttribute('href') });
      for (var k = 0; k < c.length; k++) if (/^(shop\s+)?all\b/i.test(c[k].text)) return c[k];
      return null;
    }
    function buildCategory(tab, tiles, groups) {
      var box = make('div', 'tw-mm__groups');
      var all = allLink(groups, tiles);
      if (all) {
        var bar = make('a', 'tw-mm__all');
        bar.href = all.href;
        bar.appendChild(make('span', '', /^shop\s/i.test(all.text) ? all.text : 'Shop ' + all.text.charAt(0).toLowerCase() + all.text.slice(1)));
        var go = make('span', 'tw-mm__all-go');
        go.innerHTML = GO;
        bar.appendChild(go);
        box.appendChild(bar);
      }
      each(groups, function (g, n) {
        var ls = g.links.filter(function (l) { return !(all && n === 0 && l.href === all.href); });
        if (!ls.length) return;
        var head = g.title || (n ? 'More' : '');
        if (head && !(all && n === 0 && g.title.toLowerCase() === all.text.toLowerCase())) box.appendChild(make('p', 'tw-mm__gh', head));
        var short = ls.length > 2 && ls.every(function (l) { return l.text.length <= 12; });
        var grid = make('div', 'tw-mm__gl' + (short ? ' tw-mm__gl--3' : ''));
        each(ls, function (l) {
          var a = make('a', 'tw-mm__lk' + (l.text.length > 30 ? ' is-wide' : ''), l.text);
          a.href = l.href;
          grid.appendChild(a);
        });
        box.appendChild(grid);
      });
      tab.insertBefore(box, tab.firstChild);
      if (tiles && tiles.querySelector('a')) tiles.parentNode.insertBefore(make('p', 'tw-mm__gh tw-mm__gh--feat', 'Featured'), tiles);
    }

    var back = make('button', 'tw-mm__back');
    back.type = 'button';
    back.innerHTML = '<span class="tw-mm__back-arrow">' + ARROW + '</span><span>Menu</span><strong></strong>';
    tabs.parentNode.insertBefore(back, tabs);
    var title = back.querySelector('strong');
    back.addEventListener('click', root);

    // ---- the categories as rows: photo, name and a short line of what is inside (the category's own first links)
    each(toggles.querySelectorAll('[class*="header-menu-mobile-toggle-"]'), function (b, i) {
      var name = clean(b.textContent);
      var tab = tabs.children[i];
      var tiles = tab ? tab.querySelector('[class*="header-submenu-collections-"]') : null;
      var list = tab ? tab.querySelector('ul[class*="header-menu-list-"]') : null;
      var src = picOf(tiles);
      var thumb = make('span', 'tw-mm__thumb');
      if (src) {
        var im = doc.createElement('img');
        im.alt = ''; im.loading = 'lazy'; im.width = 48; im.height = 48; im.src = sized(src, 140);
        thumb.appendChild(im);
      }
      each(Array.prototype.slice.call(b.childNodes), function (n) { if (n.nodeType === 3) b.removeChild(n); });
      var inside = [];
      if (list) each(list.children, function (li) {
        var a = li.querySelector('a[class*="header-menu-link-"]');
        var t = a ? clean(a.textContent) : '';
        if (t && inside.length < 3) inside.push(titled(t));
      });
      var txt = make('span', 'tw-mm__txt');
      txt.appendChild(make('span', 'tw-mm__name', name));
      if (inside.length) txt.appendChild(make('span', 'tw-mm__in', inside.join(' · ')));
      b.insertBefore(txt, b.firstChild);
      b.insertBefore(thumb, b.firstChild);
      var chev = make('span', 'tw-mm__chev');
      chev.innerHTML = ARROW;
      b.appendChild(chev);
      b.addEventListener('click', function () {
        title.textContent = name;
        panel.classList.add('tw-mm-sub');
        setTimeout(function () { inner.scrollTop = 0; }, 0);
      });
      if (tab) buildCategory(tab, tiles, list ? readGroups(list) : []);
    });

    // ---- the offer line at the top: the offer badge (Theme settings → CRO2610 Offers & rewards) beside the menu's own
    // delivery line. Tapping it opens the same offers and rewards sheet as the product page card.
    var oBadge = set('offer-badge'), oTitle = set('offer-title');
    if (oBadge || oTitle) {
      var heading = top.querySelector('[class*="header-menu-mobile-heading-"]');
      var offer = make('button', 'tw-mm__offer');
      offer.type = 'button';
      offer.setAttribute('aria-haspopup', 'dialog');
      offer.setAttribute('data-tw-sheet-open', 'cro2610-offers-sheet');
      offer.setAttribute('data-tw-sheet-part', 'offers');
      offer.setAttribute('data-tw-sheet-src', ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + '?section_id=cro2610-offers-sheet');
      if (oBadge) offer.appendChild(make('span', 'tw-mm__offer-badge', oBadge));
      var oLine = (heading ? clean(heading.textContent) : '') || (oBadge ? oTitle : '');
      if (oLine || !oBadge) offer.appendChild(make('span', 'tw-mm__offer-t', oLine || oTitle));
      offer.insertAdjacentHTML('beforeend', svg('<path d="M9 6l6 6-6 6"/>', 16));
      top.insertBefore(offer, top.firstChild);
      panel.classList.add('tw-mm--offer');
    }

    // ---- search
    var searchIcon = doc.getElementById('searchIcon');
    if (searchIcon) {
      var search = make('button', 'tw-mm__search');
      search.type = 'button';
      search.innerHTML = svg('<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>', 19) + '<span>Search plants, pots and care</span>';
      search.addEventListener('click', then(function () { searchIcon.click(); }));
      top.insertBefore(search, toggles);
    }

    // ---- four buttons under the categories: account, rewards, AI studio, support. Each opens the store's own popup when it is on the page,
    // and is a plain link to the matching page when it is not.
    var acts = make('div', 'tw-mm__acts');
    function act(icon, label, href, onClick) {
      var a = make('a', 'tw-mm__act');
      a.href = href;
      a.innerHTML = '<span class="tw-mm__act-ic">' + svg(ICON[icon]) + '</span>';
      a.appendChild(make('span', 'tw-mm__act-t', label));
      if (onClick) a.addEventListener('click', onClick);
      acts.appendChild(a);
      return a;
    }
    var account = inner.querySelector(':scope > ul[class*="header-menu-list-"] a');
    var accountHref = account ? account.getAttribute('href') : '/account';
    act('person', /login/i.test(accountHref) ? 'Log in' : 'Account', accountHref);
    function rewardsButton() {
      var w = doc.querySelector('.gw-widget-placeholder-LC-wrapper'), btn = null;
      if (w) each(w.querySelectorAll('*'), function (n) { if (!btn && n.shadowRoot) btn = n.shadowRoot.querySelector('.gw-drawer-open-btn'); });
      return btn;
    }
    act('gift', 'Rewards', '/pages/rewards', function (e) {
      var btn = rewardsButton();
      if (!btn) return;
      e.preventDefault();
      closeMenu();
      setTimeout(function () { btn.click(); }, 300);
    });
    // the store's AI studio opens for any link marked data-plant-studio-open
    act('spark', 'AI Studio', '/apps/studio?app=studio&utm_source=menu', closeMenu).setAttribute('data-plant-studio-open', '');
    // the chat widget opens for links to #delightchat-home; without the widget, WhatsApp
    act('chat', 'Support', '#delightchat-home', function (e) {
      if (!doc.getElementById('delightchat-widget')) { e.preventDefault(); window.location.href = WHATSAPP; return; }
      if (window.location.hash === '#delightchat-home' && window.history && window.history.replaceState) window.history.replaceState(null, '', window.location.pathname + window.location.search);
      closeMenu();
    });

    // ---- two photo cards: the shop (set in Header 13; empty = the first featured collection) and plant styling
    var firstTile = tabs.children[0] ? tabs.children[0].querySelector('a[class*="header-submenu-collection-"]') : null;
    var shop = { image: set('image'), title: set('title'), text: set('text'), link: set('link') };
    if (firstTile) {
      if (!shop.image && picOf(firstTile)) shop.image = sized(picOf(firstTile), 600);
      if (!shop.title) shop.title = nice(firstTile.textContent);
      if (!shop.link) shop.link = firstTile.getAttribute('href') || '';
    }
    var stylingTile = null;
    each(tabs.querySelectorAll('a[class*="header-submenu-collection-"]'), function (t) {
      if (!stylingTile && /styling/i.test((t.getAttribute('href') || '') + ' ' + t.textContent)) stylingTile = t;
    });
    var styling = { image: set('image2'), title: set('title2') || 'Plant styling', text: set('text2'), link: set('link2') || '/pages/plant-styling' };
    if (!styling.image && picOf(stylingTile)) styling.image = sized(picOf(stylingTile), 600);
    var duo = make('div', 'tw-mm__duo');
    function card(c, cls) {
      if (!c.title || !c.link) return;
      var a = make('a', 'tw-mm__card' + (cls ? ' ' + cls : ''));
      a.href = c.link;
      if (c.image) { var im = doc.createElement('img'); im.alt = ''; im.loading = 'lazy'; im.src = c.image; a.appendChild(im); }
      var t = make('span', 'tw-mm__card-txt');
      t.appendChild(make('strong', '', c.title));
      if (c.text) t.appendChild(make('span', '', c.text));
      a.appendChild(t);
      var go = make('span', 'tw-mm__card-go');
      go.innerHTML = GO;
      a.appendChild(go);
      duo.appendChild(a);
    }
    card(shop);
    card(styling, 'tw-mm__card--styling');
    if (duo.children.length) top.insertBefore(duo, toggles);
    // the menu's own bottom button stays only when it leads somewhere the shop card does not
    var cta = inner.querySelector('.cv3-mm__bottom-cta');
    function pathOf(h) { try { return new URL(h, window.location.href).pathname.replace(/\/$/, ''); } catch (e) { return h; } }
    if (cta && shop.link && pathOf(cta.getAttribute('href')) === pathOf(shop.link)) cta.classList.add('tw-mm-dup');

    // ---- help links under the categories
    var foot = make('div', 'tw-mm__foot');
    var footLinks = make('div', 'tw-mm__foot-links');
    each([['WhatsApp us', WHATSAPP], ['FAQs', '/pages/faqs'], ['Contact us', '/pages/contact-us']], function (l) {
      var a = make('a', '', l[0]);
      a.href = l[1];
      footLinks.appendChild(a);
    });
    foot.appendChild(footLinks);
    var social = make('div', 'tw-mm__social');
    each([['ig', 'Instagram', 'instagram.com'], ['fb', 'Facebook', 'facebook.com']], function (s) {
      var from = doc.querySelector('footer a[href*="' + s[2] + '"], [class*="footer"] a[href*="' + s[2] + '"]');
      if (!from) return;
      var a = make('a');
      a.href = from.getAttribute('href');
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', s[1]);
      a.innerHTML = svg(ICON[s[0]], 18);
      social.appendChild(a);
    });
    if (social.children.length) foot.appendChild(social);
    tabs.parentNode.insertBefore(foot, tabs.nextSibling);
    foot.parentNode.insertBefore(acts, foot);

    // know when the menu is open: start at the first screen each time, and move the floating chat buttons out of the way
    function isOpen() {
      var r = panel.getBoundingClientRect(), st = window.getComputedStyle(panel);
      return st.display !== 'none' && st.visibility !== 'hidden' && parseFloat(st.opacity || '1') > 0.5 && r.width > 0 && r.left < window.innerWidth - 8 && r.right > 8 && r.top < window.innerHeight - 8 && r.bottom > 8;
    }
    function sync() {
      var now = Date.now() > closingUntil && isOpen();
      if (now && !was) root();
      was = now;
      html.classList.toggle('tw-mm-open', now);
    }
    function soon() { setTimeout(sync, 80); setTimeout(sync, 500); setTimeout(sync, 800); }
    doc.addEventListener('click', soon, true);
    doc.addEventListener('touchend', soon, true);
    doc.addEventListener('keyup', soon, true);
  }

  // ---------------------------------------------------------------- sheets (rewards details)
  // ---------------------------------------------------------------- rewards: the "Log in" button on the offers card
  // [data-tw-rewards-login] opens the rewards app's own panel (Growave), where a visitor joins or signs in: the same
  // panel the app's "Unlock Your Personalised Offers! Log In" line on the product page opened. That line is still in
  // the page, hidden (snippets/cro2610-offers.liquid), and is pressed here; failing that, the app's floating tab.
  // The app builds its parts inside closed-off boxes (shadow roots), so they are looked up one level down.
  // If the app is not there (blocked, still loading, removed), the link goes to the sign-in page as written.
  function rewardsPanel() {
    function inside(hostSel, btnSel) {
      var hosts = doc.querySelectorAll(hostSel), i, j, kids, btn;
      for (i = 0; i < hosts.length; i++) {
        kids = [hosts[i]].concat(Array.prototype.slice.call(hosts[i].querySelectorAll('*')));
        for (j = 0; j < kids.length; j++) {
          btn = kids[j].shadowRoot ? kids[j].shadowRoot.querySelector(btnSel) : null;
          if (btn) return btn;
        }
      }
      return null;
    }
    function open() {
      try {
        var m = window.gw && window.gw.sdk && window.gw.sdk.rewards && window.gw.sdk.rewards.methods;
        if (m && typeof m.openRewardsPopup === 'function') { m.openRewardsPopup(); return true; }
      } catch (e) {}
      var btn = inside('.gw-rd-earn-points-product-page-widget-placeholder', 'button') || inside('[class*="gw-widget-placeholder"]', '.gw-drawer-open-btn');
      if (!btn) return false;
      try { btn.click(); } catch (e) { return false; }
      return true;
    }
    doc.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-tw-rewards-login]') : null;
      if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (open()) e.preventDefault();
    });
    // The offers card's rewards line: Growave's own panel where the app builds its side tab (desktop; on phones it
    // builds none). Otherwise the click goes on to the offers sheet, which opens at its rewards part (the line carries
    // data-tw-sheet-open). Runs first (capture), so the sheet does not open as well when Growave's panel does.
    doc.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-tw-rewards-open]') : null;
      if (!a || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var tab = inside('[class*="gw-widget-placeholder"]', '.gw-drawer-open-btn');
      if (!tab) return;
      try { tab.click(); e.preventDefault(); e.stopPropagation(); } catch (err) {}
    }, true);
  }

  // ---------------------------------------------------------------- sign-in links that come back to this page
  // Links marked data-tw-login-here (top bar "Log in", offers card "Log in", offers sheet "Join free") go to the store's
  // own sign-in page (new customer accounts). On the tap, the address is set to come back to the page they are on,
  // with its query and, on a product page, the size picked. Links that are not the new sign-in page are left as written.
  function loginHere() {
    doc.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[data-tw-login-here]') : null;
      if (!a) return;
      var h = a.getAttribute('href') || '';
      if (h.indexOf('customer_authentication') < 0) return;
      try {
        var back = location.pathname + location.search;
        // on a product page, the size picked (the add-to-cart form's variant), when the address does not already say it
        var f = doc.querySelector('form[action*="/cart/add"] [name="id"]');
        if (f && f.value && /^\/products\//.test(location.pathname) && !/[?&]variant=/.test(location.search)) back += (location.search ? '&' : '?') + 'variant=' + f.value;
        a.setAttribute('href', h.split('?')[0] + '?return_to=' + encodeURIComponent(back));
      } catch (err) {}
    }, true);
  }

  // Any element with data-tw-sheet-open="<id>" opens the .tw-sheet with that id; [data-tw-sheet-close], the shade and Esc close it.
  function sheets() {
    var open = null, opener = null;
    function hide() {
      if (!open) return;
      open.classList.remove('is-open');
      doc.body.classList.remove('tw-sheet-lock');
      var was = opener; open = null; opener = null;
      if (was && was.focus) { try { was.focus({ preventScroll: true }); } catch (e) {} }
    }
    function show(sheet, from, part) {
      if (open) hide();
      try { if (window.cro2610EndFade) window.cro2610EndFade(); } catch (e) {}
      if (sheet.parentNode !== doc.body) {
        each(doc.querySelectorAll('body > .tw-sheet'), function (old) { if (old.id === sheet.id) old.parentNode.removeChild(old); });
        doc.body.appendChild(sheet);       // out of the buy box, so nothing clips it or sits above it
      }
      if (!sheet.__twBound) {
        // taps inside the sheet stay in the sheet, so a menu left open under it is not closed by them
        sheet.__twBound = 1;
        sheet.addEventListener('click', function (e) {
          e.stopPropagation();
          if (e.target.closest && e.target.closest('[data-tw-sheet-close]')) { e.preventDefault(); hide(); }
        });
      }
      sheet.hidden = false;
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      doc.body.classList.add('tw-sheet-lock');
      open = sheet; opener = from;
      var panel = sheet.querySelector('.tw-sheet__panel');
      if (panel) {
        // a sheet can have parts (offers, rewards): open at the part the tapped row is about
        var to = part ? sheet.querySelector('.tw-sheet__part[data-tw-sheet-part="' + part + '"]') : null;
        var first = !to || !to.previousElementSibling || !to.previousElementSibling.classList.contains('tw-sheet__part');
        panel.scrollTop = first ? 0 : Math.max(0, to.offsetTop - 14);
        try { panel.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    doc.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var from = e.target.closest('[data-tw-sheet-open]');
      if (from) {
        var id = from.getAttribute('data-tw-sheet-open'), part = from.getAttribute('data-tw-sheet-part');
        var sheet = doc.getElementById(id), src = from.getAttribute('data-tw-sheet-src');
        if (sheet) { e.preventDefault(); show(sheet, from, part); }
        else if (src && !from.__twLoading) {
          // not on this page yet (the phone menu's offer line): fetch it once, then open it
          e.preventDefault();
          from.__twLoading = 1;
          fetch(src, { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              from.__twLoading = 0;
              var box = doc.createElement('div');
              box.innerHTML = html;
              var got = box.querySelector('.tw-sheet');
              if (!got) return;
              got.id = id;
              doc.body.appendChild(got);
              show(got, from, part);
            })
            .catch(function () { from.__twLoading = 0; });
        }
        return;
      }
      if (open && e.target.closest('[data-tw-sheet-close]')) { e.preventDefault(); hide(); }
    });
    doc.addEventListener('keydown', function (e) { if (open && (e.key === 'Escape' || e.keyCode === 27)) hide(); });
    sheetApi = { show: show, hide: hide };
  }

  /* ---------------------------------------------------------------- desktop menu with photo cards
     Switched on in Theme settings → CRO v3 — Features → "Desktop menu" (snippets/cro2610-assets.liquid sets
     html.cro2610-mega and window.TW_MEGA). Header 13 prints the panels as before; from 1024 px this marks them up
     and cro2610.css ("DESKTOP MENU: PHOTO CARDS") draws them:
       - a tab whose menu has groups of links: the groups as columns, and beside them up to three photo cards
         (the tab's own featured photos first, then collections from its menu);
       - a tab with one level of links only: every link as a photo card in a row;
       - a long column shows its first links and a "more" button; a group without links of its own becomes a
         link under the columns; a photo card gives way when the columns would otherwise wrap to a second row.
     A card made from a menu link gets its photo from the collection (its own picture, or its first product's
     when it has none), asked for when that tab is first pointed at and remembered for a day. Nothing is
     fetched while the page loads. */
  function megaMenu() {
    var html = doc.documentElement, cfg = window.TW_MEGA || {};
    if (!html.classList.contains('cro2610-mega')) return;
    if (!megaMenu.__mq && window.matchMedia) {
      megaMenu.__mq = 1;
      // a window opened narrow and then widened gets its panels marked up then
      try { window.matchMedia('(min-width: 1024px)').addEventListener('change', function (e) { if (e.matches) megaMenu(); }); } catch (e) {}
    }
    if (!(window.matchMedia && window.matchMedia('(min-width: 1024px)').matches)) return;
    var tabs = doc.querySelectorAll('[class*="header-menu-item-main-"]');
    if (!tabs.length) return;
    var maxCards = Math.max(0, Math.min(4, cfg.cards == null ? 3 : Number(cfg.cards) || 0));
    var rows = Math.max(3, Number(cfg.rows) || 6);
    var DAY = 864e5, mem = {}, fits = megaMenu.__fits || (megaMenu.__fits = []);
    var store = (function () { try { return window.localStorage; } catch (e) { return null; } })();
    // the address a link goes to, as written in the menu ("#" and empty links go nowhere)
    function path(el) {
      var raw = el && el.getAttribute ? String(el.getAttribute('href') || '').trim() : '';
      if (!raw || raw.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(raw)) return '';
      try { var u = new URL(raw, window.location.href); return u.origin === window.location.origin ? u.pathname.replace(/\/+$/, '') : ''; } catch (e) { return ''; }
    }
    function text(el) { return String(el.textContent || '').replace(/\s+/g, ' ').trim(); }
    // "ALL PLANTS" → "All Plants" (a name of several words typed in capitals; one word such as a brand stays)
    function calm(el) {
      var t = text(el);
      if (!el || /[a-z]/.test(t) || t.split(' ').length < 2) return;
      el.textContent = t.toLowerCase().replace(/(^|[\s\-\/(&])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
    }
    function sized(url, w) {
      if (!url) return '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      return /[?&]width=\d+/.test(url) ? url : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function getJSON(url) {
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    // the photo for a collection or product address ('' when there is none)
    function picFor(p) {
      if (mem[p] !== undefined) return Promise.resolve(mem[p]);
      try {
        var raw = store && store.getItem('twmg:' + p), o = raw ? JSON.parse(raw) : null;
        if (o && Date.now() - o.t < DAY) { mem[p] = o.u; return Promise.resolve(o.u); }
      } catch (e) {}
      var m = /^\/collections\/([^\/]+)$/.exec(p), job;
      if (m && m[1] !== 'all') {
        job = getJSON('/collections/' + m[1] + '.json').then(function (d) {
          var src = d && d.collection && d.collection.image && d.collection.image.src;
          if (src) return src;
          return getJSON('/collections/' + m[1] + '/products.json?limit=1').then(function (x) {
            var pr = x && x.products && x.products[0];
            return (pr && pr.images && pr.images[0] && pr.images[0].src) || '';
          });
        });
      } else if ((m = /^\/products\/([^\/]+)$/.exec(p))) {
        job = getJSON('/products/' + m[1] + '.js').then(function (d) { return (d && (d.featured_image || (d.images && d.images[0]))) || ''; });
      } else job = Promise.resolve('');
      return job.then(function (u) {
        u = u || '';
        mem[p] = u;
        try { if (store) store.setItem('twmg:' + p, JSON.stringify({ t: Date.now(), u: u })); } catch (e) {}
        return u;
      });
    }
    function cardFrom(a) {
      var el = doc.createElement('a');
      el.className = 'tw-mg__card tw-mg__card--auto';
      el.href = a.getAttribute('href') || '#';
      el.innerHTML = '<span class="tw-mg__pic"></span><span class="tw-mg__label"></span>';
      el.lastChild.textContent = text(a);
      return el;
    }
    function fill(panel) {
      if (panel.__twPics) return;
      panel.__twPics = 1;
      each(panel.querySelectorAll('.tw-mg__card--auto'), function (el) {
        picFor(path(el)).then(function (u) {
          if (!u) { el.classList.add('tw-mg__card--text'); return; }
          var img = new Image();
          img.alt = ''; img.decoding = 'async';
          img.onload = function () { el.classList.add('is-in'); };
          img.onerror = function () { el.classList.add('tw-mg__card--text'); };
          img.src = sized(u, 480);
          el.firstChild.appendChild(img);
        });
      });
    }
    each(tabs, function (item) {
      if (item.__twMega) return;
      var panel = item.querySelector(':scope > [class*="header-submenu-"]');
      var links = panel ? panel.querySelector('[class*="header-submenu-menu-"]') : null;
      var list = links ? links.querySelector(':scope > ul') : null;
      if (!list) return;
      item.__twMega = 1;
      var zone = panel.querySelector('[class*="header-submenu-collections-"]');
      if (!zone) { zone = doc.createElement('div'); links.parentNode.appendChild(zone); }
      panel.classList.add('tw-mg');
      zone.classList.add('tw-mg__zone');
      // the panel's right edge mirrors its left one (Header 13 leaves the right side without padding)
      try { var padL = window.getComputedStyle(links.parentNode).paddingLeft; if (parseFloat(padL) > 0) panel.style.setProperty('--tw-mg-pad', padL); } catch (e) {}
      var tiles = [].slice.call(zone.querySelectorAll('a[class*="header-submenu-collection-"]'));
      each(tiles, function (t) { t.classList.add('tw-mg__card'); calm(t.querySelector('[class*="header-submenu-collection-title-"]')); });
      var groups = [], singles = [];
      each(list.children, function (li) { (li.querySelector(':scope > ul') ? groups : singles).push(li); });
      var used = tiles.map(function (t) { return path(t); });

      if (!groups.length) {
        // one level of links: every link is a photo card; a featured photo with the same address keeps its picture
        if (!singles.length) return;
        panel.classList.add('tw-mg--cards');
        var shown = 0;
        each(singles, function (li) {
          var a = li.querySelector(':scope > a');
          if (!a || shown >= 6) return;
          var p = path(a), same = tiles.filter(function (t) { return path(t) === p; })[0];
          zone.appendChild(same || cardFrom(a));
          if (same) same.__twKept = 1;
          shown++;
        });
        each(tiles, function (t) { if (!t.__twKept) { if (shown < 6) { zone.appendChild(t); shown++; } else t.hidden = true; } });
        zone.style.setProperty('--tw-mg-n', String(Math.max(shown, 3)));
      } else {
        // columns of links with photo cards beside them
        panel.setAttribute('data-tw-mg-cols', String(Math.min(groups.length, 5)));
        var allow = groups.length >= 4 ? Math.min(maxCards, 2) : maxCards, have = 0;
        each(tiles, function (t) { if (have < allow) have++; else t.hidden = true; });
        var cands = [];
        each(groups, function (li) { var a = li.querySelector(':scope > a'); if (a) cands.push(a); });
        each(groups, function (li) { each(li.querySelectorAll(':scope > ul > li > a'), function (a) { cands.push(a); }); });
        each(cands, function (a) {
          var p = path(a);
          if (have >= allow || !/^\/collections\/[^\/]+$/.test(p) || p === '/collections/all' || used.indexOf(p) > -1) return;
          used.push(p);
          zone.appendChild(cardFrom(a));
          have++;
        });
        zone.style.setProperty('--tw-mg-n', String(have));
        if (!have) panel.classList.add('tw-mg--nocards');
        // a long column: its first links, then "more"
        each(groups, function (li) {
          var ul = li.querySelector(':scope > ul'), kids = ul ? ul.children : [];
          if (kids.length <= rows + 2) return;
          var extra = kids.length - rows;
          each([].slice.call(kids, rows), function (k) { k.classList.add('tw-mg__extra'); });
          var more = doc.createElement('li');
          more.className = 'tw-mg__moreli';
          more.innerHTML = '<button type="button" class="tw-mg__more" aria-expanded="false"></button>';
          var btn = more.firstChild;
          btn.textContent = '+ ' + extra + ' more';
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var open = !li.classList.contains('is-open');
            li.classList.toggle('is-open', open);
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            btn.textContent = open ? 'Show fewer' : '+ ' + extra + ' more';
          });
          ul.appendChild(more);
        });
        // a group with no links of its own: one line under the columns
        if (singles.length) {
          var foot = doc.createElement('div');
          foot.className = 'tw-mg__foot';
          each(singles, function (li) { var a = li.querySelector(':scope > a'); if (a) { a.classList.add('tw-mg__footlink'); foot.appendChild(a); } li.hidden = true; });
          links.appendChild(foot);
        }
      }
      // the columns stay on one row: a photo card gives way when they would wrap (one card always stays)
      var fit = function () {
        if (panel.classList.contains('tw-mg--cards')) return;
        var cards = [].filter.call(zone.querySelectorAll('.tw-mg__card'), function (c) { return !c.hidden; });
        var cols = [].filter.call(list.children, function (li) { return !li.hidden; });
        each(cards, function (c) { c.classList.remove('is-cut'); });
        panel.classList.remove('tw-mg--fit0');
        var left = cards.length;
        for (var i = cards.length - 1; i >= 0; i--) {
          if (cols.length < 2 || cols[cols.length - 1].offsetTop <= cols[0].offsetTop + 4) break;
          cards[i].classList.add('is-cut');
          left--;
          if (!left) panel.classList.add('tw-mg--fit0');
        }
      };
      fit();
      fits.push(fit);
      var go = function () { fit(); fill(panel); };
      item.addEventListener('pointerenter', go);
      item.addEventListener('focusin', go);
    });
    if (fits.length && !megaMenu.__resize) {
      megaMenu.__resize = 1;
      var timer = null;
      window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(function () { each(fits, function (f) { try { f(); } catch (e) {} }); }, 180); });
    }
  }

  ready(function () {
    reveal();
    heroVideo();
    thumbs();
    each(doc.querySelectorAll('.tw-finder'), finder);
    each(doc.querySelectorAll('.tw-ship'), shipLine);
    each(doc.querySelectorAll('[data-tw-keys]'), keys);
    studioPill();
    each(doc.querySelectorAll('[data-tw-cfaq]'), cfaq);
    each(doc.querySelectorAll('[data-tw-scrolly]'), scrolly);
    each(doc.querySelectorAll('[data-tw-ugc]'), ugc);
    each(doc.querySelectorAll('[data-tw-cluster]'), cluster);
    each(doc.querySelectorAll('[data-tw-family]'), family);
    drawerCompanions();
    cartPage();
    cartCount();
    atcTotal();
    sheets();
    rewardsPanel();
    loginHere();
    added();
    evenGaps();
    potPolish();
    optionPhoto();
    phoneMenu();
    megaMenu();
    buyBar();
    doc.addEventListener('shopify:section:load', phoneMenu);
    doc.addEventListener('shopify:section:load', megaMenu);
  });
})();
